
import React, { useEffect, useState } from "react";
import { useRef } from 'react';
import PhoneInput from 'react-phone-input-2';
import { RiInformation2Line } from "react-icons/ri";
import { useLocation } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import axios from "axios";
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import StepLabel from '@mui/material/StepLabel';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import ManIcon from '@mui/icons-material/Man';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import EscalatorWarningIcon from '@mui/icons-material/EscalatorWarning';
import BabyChangingStationIcon from '@mui/icons-material/BabyChangingStation';
import { Box, Button, Tabs, Tab, Paper, Typography, Grid, Card, CardContent, Divider, FormControl } from "@mui/material";
import { Add, Remove } from '@mui/icons-material';
import Accordion from '@mui/material/Accordion';
import { FormLabel } from '@mui/material';
import { Backdrop } from "@mui/material";
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import 'react-phone-input-2/lib/style.css';
import '../PaymentProcess/PaymentProcess.css';
import HeaderComponent from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import BookingSummary from "./BookingSummary";
import GstDetailsModal from "./GstDetailsModal";
import TravallingCondition from "../travelling-terms-condition/Travelling-Conditions";
import NeedGhoomo from "../Why-We-need-page/NeedGhoomo";
import countryData from "../../Data/CountryData.json";
import stateData from "../../Data/StateData.json";
import environment from '../../environment/environment';
import Sidebar from '../../components/Sidebar/Sidebar';
import CustomSpinner from '../../components/CustomeSpinner/CustomeSpinner';

const steps = ['Departure city & date', 'Travellers count', 'Travellers details', 'Preview Details & Make Payment'];

const PaymentProcess = (props, { isShowDatesAndPrices }) => {
    const location = useLocation();
    const { packageData } = location.state || {};
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const [departureCity, setDepartureCity] = React.useState('Mumbai');
    const [departureDate, setDepartureDate] = React.useState('');
    const [travellerCount, setTravellerCount] = React.useState('');
    const [cityError, setCityError] = useState('');
    const [departureDateError, setDepartureDateError] = useState('');
    const [formattedDate, setFormattedDate] = useState('');
    const today = new Date().toISOString().split('T')[0];
    const [activeTab, setActiveTab] = useState(0);
    const [organizedDates, setOrganizedDates] = useState({});
    const [months, setMonths] = useState([]);
    const [adultCount, setAdultCount] = useState(2);
    const [childCount, setChildCount] = useState(0);
    const [infantCount, setInfantCount] = useState(0);
    const [travellerDetailsList, setTravellerDetailsList] = React.useState([{ adultDetails: [], childDOB: [], infantDOB: [], }]);
    const [totalPrice, setTotalPrice] = useState('');
    const [expanded, setExpanded] = useState('');
    const [isGST, setIsGST] = React.useState('No');
    const handleChange = (event, newValue) => { setActiveTab(newValue) };
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [email, setEmail] = useState('');
    const [stateName, setStateName] = useState('');
    const [national, setNational] = useState('');
    const [pinCode, setPinCode] = useState('');
    const [aadharNo, setAadharNo] = useState('');
    const [gender, setGender] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [childDOB, setChildDOB] = useState('');
    const [childDOBError, setChildDOBError] = useState('');
    const [firstNameError, setFirstNameError] = useState('');
    const [lastNameError, setLastNameError] = useState('');
    const [mobileNoError, setMobileNoError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [stateNameError, setStateNameError] = useState('');
    const [nationalError, setNationalError] = useState('');
    const [pinCodeError, setPinCodeError] = useState('');
    const [aadharNoError, setAadharNoError] = useState('');
    const [genderError, setGenderError] = useState('');
    const [dateOfBirthError, setDateOfBirthError] = useState('');
    const genders = ['Male', 'Female', 'Others'];
    const [isEdit, setIsEdit] = useState(false);
    const [isChild, setIsChild] = useState(false);
    const [isInfant, setIsInfant] = useState(false);
    const [indexId, setIndexId] = useState('');
    const todayDate = new Date();
    const childMinDate = new Date(todayDate.getFullYear() - 11, todayDate.getMonth(), todayDate.getDate()).toISOString().split('T')[0];
    const childMaxDate = new Date(todayDate.getFullYear() - 5, todayDate.getMonth(), todayDate.getDate()).toISOString().split('T')[0];
    const infantMinDate = new Date(todayDate.getFullYear() - 5, todayDate.getMonth(), todayDate.getDate()).toISOString().split('T')[0];
    const infantMaxDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate()).toISOString().split('T')[0];
    const adultMaxDate = new Date(todayDate.getFullYear() - 12, todayDate.getMonth(), todayDate.getDate()).toISOString().split('T')[0];
    const adultMinDate = new Date(todayDate.getFullYear() - 100, todayDate.getMonth(), todayDate.getDate()).toISOString().split('T')[0];
    const [infantDOB, setInfantDOB] = useState('');
    const [doubleSharingPrice, setDoubleSharingPrice] = useState('');
    const [triplesharingPrice, setTripleSharingPrice] = useState('');
    const [quadsharingPrice, setQuadSharingPrice] = useState('');
    const [infantDOBError, setInfantDOBError] = useState('');
    const [BookingDetails, setBookingDetails] = useState([]);
    const [submitFormCount, setSubmitFormCount] = useState(0);
    const [isGstModal, setIsGstModal] = useState(false);
    const [gstDetails, setGstDetails] = useState([]);
    const [panNo, setPanNo] = useState('');
    const [basePrice, setBasePrice] = useState('');
    const [newPrice, setNewPrice] = useState('');
    const [panNoError, setPanNoError] = useState('');
    const [isPanNo, setIsPanNo] = useState('No');
    const [nationsState, setNationsState] = useState([]);
    const [selectedNationality, setSelectedNationality] = useState('');
    const [selectedCityData, setSelectedCityData] = useState(null);
    const [roomType, setRoomType] = useState('');
    const [isAdultForm, setIsAdultForm] = useState(true);
    const [isChildForm, setIsChildForm] = useState(false);
    const [totalRoomCount, setTotalRoomCount] = useState('');
    const [totalTravellers, setTotalTravellers] = useState('');
    const [childPrice, setChildPrice] = useState(0);
    const [perAdultPrice, setPerAdultPrice] = useState('');
    const [perChildPrice, setPerChildPrice] = useState('');
    const [isGstEdit, setIsGstEdit] = useState(false);
    const [aadharImg, setAadharImg] = useState('');
    const [aadharImgError, setAadharImgError] = useState('');
    const [adultPackagePrice, setAdultPackagePrice] = useState('');
    const [perAdultPriceArray, setPerAdultPriceArray] = useState([]);
    const [perChildPriceArray, setPerChildPriceArray] = useState([]);
    const aadharFileInputRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [country,setCountry]=useState('in');
    const [dialCode, setDialCode]=useState('91');
    const joinObject = [{
        cityName: "Joining/Leaving",
        packageDateDetails: [],
    }];

    useEffect(() => {
        window.scrollTo(0, 0)
        packageData?.departureDetails.forEach(element => {
            element?.packageDateDetails?.forEach(date => {
                const alreadyExists = joinObject[0].packageDateDetails.some(
                    existing => existing.fullDate === date.fullDate
                );
                if (!alreadyExists) {
                    joinObject[0].packageDateDetails.push({
                        fullDate: date.fullDate,
                        packageDate: date.packageDate,
                        packageDay: date.packageDay,
                        packageMonth: date.packageMonth,
                        packageYear: date.packageYear

                    });
                }
            });
            setChildPrice(packageData.childPrice)
        });
        const cityName = joinObject[0].cityName;
        const alreadyAdded = packageData?.departureDetails.some(
            detail => detail.cityName === cityName
        );

        if (!alreadyAdded) {
            packageData?.departureDetails.push(joinObject[0]);
        }

    }, [packageData]);

    useEffect(() => {
        setNational(101);
        setSelectedNationality('India');
        const filteredStates = stateData.filter(e => e.id === 101)
        setNationsState(filteredStates[0].states);
        if (!departureCity || !packageData?.departureDetails) {
            setMonths([]);
            setOrganizedDates({});
            return;
        }

        const cityData = packageData.departureDetails.find(
            (departure) => departure.cityName === departureCity
        );
        if (!cityData || !cityData.packageDateDetails) {
            setMonths([]);
            setOrganizedDates({});
            setSelectedCityData(null);
            return;
        }
        setSelectedCityData(cityData);
        const datesByMonth = {};
        const monthSet = new Set();
        const seenDates = new Set(); // Track unique dates to prevent duplicates
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        cityData.packageDateDetails.forEach(dateInfo => {
            const dateStr = dateInfo.fullDate; 
            if (seenDates.has(dateStr)) {
                return;
            }
            const [day, month, year] = dateStr.split('/');
            const dateObj = new Date(`${year}-${month}-${day}`);
            if (dateObj < today) {
                return; 
            }
            seenDates.add(dateStr);
            const monthKey = dateObj.toLocaleString('default', { month: 'long', year: 'numeric' });
            if (!datesByMonth[monthKey]) {
                datesByMonth[monthKey] = [];
                monthSet.add(monthKey);
            }
            const dayOfWeek = dateInfo.packageDay; // "Tuesday", "Saturday", etc.
            datesByMonth[monthKey].push({
                date: dateObj,
                day: parseInt(day),
                dayOfWeek: dayOfWeek.substring(0, 3), // Convert to short form like "Tue", "Sat"
                // price: `Rs.${defaultPrice}`, // You can add price logic here if needed
                fullFormatted: dateStr,
                packageDateId: dateInfo.packageDateId, // Store this for booking reference
            });
        });
        Object.keys(datesByMonth).forEach(monthKey => {
            datesByMonth[monthKey].sort((a, b) => a.date - b.date);
        });
        const sortedMonths = Array.from(monthSet).sort((a, b) => {
            const dateA = new Date(a);
            const dateB = new Date(b);
            return dateA - dateB;
        });
        setMonths(sortedMonths);
        setOrganizedDates(datesByMonth);
        if (sortedMonths.length > 0 && activeTab >= sortedMonths.length) {
            setActiveTab(0);
        }
    }, [departureCity, packageData]);

    useEffect(() => {
        const totalCount = adultCount + childCount + infantCount
        setTotalTravellers(totalCount);
        const roomCount = adultCount + childCount;
        setTotalRoomCount(roomCount);
        const newRoomType = getRoomType(roomCount);
        setRoomType(newRoomType);
    }, [adultCount, childCount, infantCount]);

    useEffect(() => {
        if (departureCity === 'Joining/Leaving') {
            setDoubleSharingPrice(packageData?.roomDetails[0].packageCostForJoinLeave);
            setTripleSharingPrice(packageData?.roomDetails[1].packageCostForJoinLeave);
            setQuadSharingPrice(packageData?.roomDetails[2].packageCostForJoinLeave);
        } else {
            setDoubleSharingPrice(packageData?.roomDetails[0].roomPrice)
            setTripleSharingPrice(packageData?.roomDetails[1].roomPrice)
            setQuadSharingPrice(packageData?.roomDetails[2].roomPrice)
        }
        setBasePrice(packageData?.packageWithDiscountPrices);
    }, [departureCity, packageData]);

    useEffect(() => {
        const options = getRoomOptions(totalRoomCount);
        if (options?.length > 0) {
            setRoomType(options[0].value);
            setNewPrice(calculatePrice(totalRoomCount, options[0].value));
        } else {
            setRoomType('');
            setNewPrice(0);
        }
    }, [totalRoomCount, departureCity, doubleSharingPrice, triplesharingPrice, quadsharingPrice]);

    const handleFileUpload = (event) => {
        if (!event.target.files || event.target.files.length === 0) {
            setAadharImgError("Please select a file");
            return;
        }
        const file = event.target.files[0];
        const type = file.type;
        // Clear any previous errors
        setAadharImgError("");
        if (
            type.includes("pdf") ||
            type.includes("PDF") ||
            type.includes("txt") ||
            type.includes("TXT") ||
            type.includes("DOC") ||
            type.includes("doc") ||
            type.includes("docx") ||
            type.includes("DOCX") ||
            type.includes("MP3") ||
            type.includes("mp3") ||
            type.includes("MP4") ||
            type.includes("mp4") ||
            type.includes("DOCUMENT") ||
            type.includes("document")
        ) {
            setAadharImgError("Document files are not allowed! Please select an image file.");
            event.target.value = "";
            return;
        }
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (file.size > maxSize) {
            setAadharImgError("File size too large. Please select a file smaller than 5MB.");
            event.target.value = "";
            return;
        }
        const formData = new FormData();
        formData.append("file", file);
        // You might want to show loading state here
        // setIsUploading(true);

        axios({
            url: `${environment.config.apiBaseUrl}upload/uploadImage`,
            method: "POST",
            headers: {
                authorization: "your token comes here",
            },
            data: formData,
        })
            .then((res) => {
                if (res && res.data && res.data.imageUrl) {
                    setAadharImg(res.data.imageUrl);
                    setAadharImgError("");
                } else {
                    setAadharImgError("Failed to upload image. Please try again.");
                }
            })
            .catch((err) => {
                console.error("Upload error:", err);
                setAadharImgError("Failed to upload image. Please try again.");
                event.target.value = ""; // Clear the input on error
            })
            .finally(() => {
                // setIsUploading(false);
            });
    };
    const clearAadharField = () => {
        // Clear the file input
        if (aadharFileInputRef.current) {
            aadharFileInputRef.current.value = "";
        }
        setAadharImg("");
        setAadharImgError("");
    };
    const getRoomType = (count) => {
        switch (count) {
            case 1: return "1 Single Room";

            case 2: return "Double Sharing";

            case 3: return "Triple Sharing(3 people in single Room)";

            case 4: return "2 Double Sharing Rooms";

            case 5: return "Triple Sharing + Double Sharing Room";

            case 6: return "3 Double Sharing Room";

            case 7: return "1 Quad Sharing Room + 1 Triple Sharing Room";

            case 8: return "4 Double Sharing Room";

            case 9: return "3 Triple Sharing Room";

            case 10: return "5 Double Sharing Room";

            default: return '';
        }
    }

    const handleNext = () => {
        let hasError = false;
        switch (activeStep) {
            case 0:
                if (!departureCity) {
                    setCityError("Please select a departure city.");
                    hasError = true;
                }
                if (!formattedDate) {
                    setDepartureDateError("Please select a departure date.");
                    hasError = true;
                }
                break;
            case 1:
                if ((adultCount + childCount) < 2) {
                    toast.error('At least 2 Travellers are required!');
                    hasError = true;
                }
                break;
            case 2:
                if (adultCount !== submitFormCount) {
                    toast.error(`Please add travellers details.`)
                    hasError = true;
                } else if (childCount !== (travellerDetailsList[0]?.childDOB?.length ?? 0)) {
                    toast.error(`Please add travellers details.`)
                    hasError = true;
                    console.log(travellerDetailsList)
                }
                break;

            default:
                break;
        }

        if (hasError) return;
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false)
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }, 500)


        if (activeStep === 2) {
            const passengers = {
                departureCity: departureCity,
                departureDate: departureDate,
                travellerDetailsList: travellerDetailsList,
            }

            setBookingDetails(prevBookingDetails => {
                // Ensure prevBookingDetails is an array
                const currentBookings = Array.isArray(prevBookingDetails) ? prevBookingDetails : [];
                // Create a copy of the array
                const updatedBookings = [...currentBookings];
                // For step 2, always update/set the data at index 0 (or use activeStep as index if needed)
                updatedBookings[0] = passengers;
                return updatedBookings;
            });
        }
    };
    const getRoomOptions = (adultCount) => {
        switch (adultCount) {
            case 1:
                return [
                    { value: "Double Sharing", label: "Double Sharing (1 person in One Room)" },
                ];
            case 2:
                return [
                    { value: "Double Sharing", label: "Double Sharing (2 person in One Room)" },
                ];
            case 3:
                return [
                    { value: "Triple Sharing(3 people in single Room)", label: "Triple Sharing (3 People in single room)" },
                ];
            case 4:
                return [
                    { value: "Quad Sharing Room", label: "Quad Sharing Room (4 People in one Room)" },
                    { value: "2 Double Sharing Rooms", label: "Double Sharing Rooms (2 Adults in each)" },
                   
                ];
            case 5:
                return [
                    { value: "Triple Sharing + Double Sharing Room", label: "Triple Sharing Room (3 People in Room) + Double Sharing Room (2 People in Room)" },
                ];
            case 6:
                return [
                    { value: "Quad Sharing Room + Double sharing Room", label: "Quad Sharing Room (4 People) + Double Sharing Room (2 People)" },
                    { value: "2 Triple Sharing Room", label: "2 Triple Sharing Rooms (3 People in Room)" },
                    { value: "3 Double Sharing Room", label: "3 Double Sharing Room (2 People in Room)" },
                   
                    
                ];
            case 7:
                return [
                    { value: "1 Quad Sharing Room + 1 Triple Sharing Room", label: "1 Quad Sharing Room (4 People) + 1 Triple Sharing Room (3 People)" },
                ];
            case 8:
                return [
                    { value: "2 Quad Sharing Room", label: "2 Quad Sharing Room (4 People in Room)" },
                    { value: "2 Triple Sharing Room + 1 Double Sharing Room", label: "2 Triple Sharing Room (3 People) + 1 Double Sharing Room (2 People)" },
                    { value: "4 Double Sharing Room", label: "4 Double Sharing Room (2 People in Room)" },
                ];
            case 9:
                return [
                    { value: "1 Quad Sharing Room + 1Triple Sharing Room + 1 Double Sharing Room", label: "1 Quad Sharing (4) + 1 Triple Sharing (3) + 1 Double Sharing (2)" },
                    { value: "3 Triple Sharing Room", label: "3 Triple Sharing Room (3 People in Room)" },
                ];
            case 10:
                return [
                    { value: "2 Quad Sharing Room + 1 Double Sharing Room", label: "2 Quad Sharing (4 People) + 1 Double Sharing (2 People)" },
                    { value: "2 Triple Sharing Room + 1 Quad Sharing Room", label: "1 Quad Sharing (4 People) + 2 Triple Sharing (3 People)" },
                    { value: "2 Triple Sharing Room + 2 Double Sharing Room", label: "2 Double Sharing (2 People) + 2 Triple Sharing (3 People)" },
                    { value: "5 Double Sharing Room", label: "5 Double Sharing Room (2 People in Room)" },
                ];
            default:
                return [];
        }
    };
    
    // const calculatePrice = (adults, room) => {
    //     let roomAddon = 0;
    //     let perAdultPrices = [];
    //     let perChildPrices = [];
    
    //     switch (room) {
    //         case 'Single Room':
    //             roomAddon = basePrice;
    //             perAdultPrices = Array(adults).fill(basePrice);
    //             break;
    
    //         case 'Double Sharing':
    //             roomAddon = (adultCount * doubleSharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(doubleSharingPrice);
    //             setAdultPackagePrice(doubleSharingPrice);
    //             break;
    
    //         case 'Triple Sharing(3 people in single Room)':
    //             roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(triplesharingPrice);
    //             setAdultPackagePrice(triplesharingPrice);
    //             break;
    
    //         case '2 Double Sharing Rooms':
    //             roomAddon = (adultCount * doubleSharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(doubleSharingPrice);
    //             setAdultPackagePrice(doubleSharingPrice);
    //             break;
    
    //         case 'Quad Sharing Room':
    //             roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(quadsharingPrice);
    //             setAdultPackagePrice(quadsharingPrice);
    //             break;
    
    //         case 'Triple Sharing + Double Sharing Room':
    //             roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(triplesharingPrice);
    //             setAdultPackagePrice(triplesharingPrice);
    //             break;
    
    //         case '3 Double Sharing Room':
    //             roomAddon = (adultCount * doubleSharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(doubleSharingPrice);
    //             setAdultPackagePrice(doubleSharingPrice);
    //             break;
    
    //         case '2 Triple Sharing Room':
    //             roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(triplesharingPrice);
    //             setAdultPackagePrice(triplesharingPrice);
    //             break;
    
    //         case 'Quad Sharing Room + Double sharing Room':
    //             roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(quadsharingPrice);
    //             setAdultPackagePrice(quadsharingPrice);
    //             break;
    
    //         case '1 Quad Sharing Room + 1 Triple Sharing Room':
    //             roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(quadsharingPrice);
    //             setAdultPackagePrice(quadsharingPrice);
    //             break;
    
    //         case '4 Double Sharing Room':
    //             roomAddon = (adultCount * doubleSharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(doubleSharingPrice);
    //             setAdultPackagePrice(doubleSharingPrice);
    //             break;
    
    //         case '2 Quad Sharing Room':
    //             roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(quadsharingPrice);
    //             setAdultPackagePrice(quadsharingPrice);
    //             break;
    
    //         case '2 Triple Sharing Room':
    //             roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(triplesharingPrice);
    //             setAdultPackagePrice(triplesharingPrice);
    //             break;
    
    //         case '2 Triple Sharing Room + 1 Double Sharing Room':
    //             roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(triplesharingPrice);
    //             setAdultPackagePrice(triplesharingPrice);
    //             break;
    
    //         case '3 Triple Sharing Room':
    //             roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(triplesharingPrice);
    //             setAdultPackagePrice(triplesharingPrice);
    //             break;
    
    //         case '1 Quad Sharing Room + 1Triple Sharing Room + 1 Double Sharing Room':
    //             roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(triplesharingPrice);
    //             setAdultPackagePrice(triplesharingPrice);
    //             break;
    
    //         case '5 Double Sharing Room':
    //             roomAddon = (adultCount * doubleSharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(doubleSharingPrice);
    //             setAdultPackagePrice(doubleSharingPrice);
    //             break;
    
    //         case '2 Quad Sharing Room + 1 Double Sharing Room':
    //             roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(quadsharingPrice);
    //             setAdultPackagePrice(quadsharingPrice);
    //             break;
    
    //         case '2 Triple Sharing Room + 1 Quad Sharing Room':
    //             roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(triplesharingPrice);
    //             setAdultPackagePrice(triplesharingPrice);
    //             break;
    
    //         case '2 Triple Sharing Room + 2 Double Sharing Room':
    //             roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
    //             perAdultPrices = Array(adultCount).fill(triplesharingPrice);
    //             setAdultPackagePrice(triplesharingPrice);
    //             break;
    
    //         default:
    //             roomAddon = 0;
    //     }
    
    //     perChildPrices = Array(childCount).fill(childPrice);
    //     setPerAdultPriceArray(perAdultPrices);
    //     setPerChildPriceArray(perChildPrices);
    
    //     return roomAddon;
    // };
    const calculatePrice = (adults, room) => {
        let roomAddon = 0;
        let perAdultPrices = [];
        let perChildPrices = [];
    
        switch (room) {
            case 'Single Room':
                roomAddon = basePrice;
                perAdultPrices = Array(adults).fill(basePrice);
                break;
    
            case 'Double Sharing':
                roomAddon = (adultCount * doubleSharingPrice) + (childCount * childPrice);
                perAdultPrices = Array(adultCount).fill(doubleSharingPrice);
                setAdultPackagePrice(doubleSharingPrice);
                break;
    
            case 'Triple Sharing(3 people in single Room)':
                roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
                perAdultPrices = Array(adultCount).fill(triplesharingPrice);
                setAdultPackagePrice(triplesharingPrice);
                break;
    
            case '2 Double Sharing Rooms':
                roomAddon = (adultCount * doubleSharingPrice) + (childCount * childPrice);
                perAdultPrices = Array(adultCount).fill(doubleSharingPrice);
                setAdultPackagePrice(doubleSharingPrice);
                break;
    
            case 'Quad Sharing Room':
                roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
                perAdultPrices = Array(adultCount).fill(quadsharingPrice);
                setAdultPackagePrice(quadsharingPrice);
                break;
    
            case 'Triple Sharing + Double Sharing Room':
                if (adultCount <= 3) {
                    roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(triplesharingPrice);
                    setAdultPackagePrice(triplesharingPrice);
                } else if (adultCount <= 5) {
                    const adultsInTriple = 3;
                    const adultsInDouble = adultCount - 3;
                    roomAddon = (adultsInTriple * triplesharingPrice) + (adultsInDouble * doubleSharingPrice) + (childCount * childPrice);
                    perAdultPrices = [
                        ...Array(adultsInTriple).fill(triplesharingPrice),
                        ...Array(adultsInDouble).fill(doubleSharingPrice)
                    ];
                    setAdultPackagePrice(doubleSharingPrice);
                } else {
                    roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(triplesharingPrice);
                    setAdultPackagePrice(triplesharingPrice);
                }
                break;
    
            case '3 Double Sharing Room':
                roomAddon = (adultCount * doubleSharingPrice) + (childCount * childPrice);
                perAdultPrices = Array(adultCount).fill(doubleSharingPrice);
                setAdultPackagePrice(doubleSharingPrice);
                break;
    
            case '2 Triple Sharing Room':
                roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
                perAdultPrices = Array(adultCount).fill(triplesharingPrice);
                setAdultPackagePrice(triplesharingPrice);
                break;
    
            case 'Quad Sharing Room + Double sharing Room':
                if (adultCount <= 4) {
                    roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(quadsharingPrice);
                    setAdultPackagePrice(quadsharingPrice);
                } else if (adultCount <= 6) {
                    const adultsInQuad = 4;
                    const adultsInDouble = adultCount - 4;
                    roomAddon = (adultsInQuad * quadsharingPrice) + (adultsInDouble * doubleSharingPrice) + (childCount * childPrice);
                    perAdultPrices = [
                        ...Array(adultsInQuad).fill(quadsharingPrice),
                        ...Array(adultsInDouble).fill(doubleSharingPrice)
                    ];
                    setAdultPackagePrice(doubleSharingPrice);
                } else {
                    roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(quadsharingPrice);
                    setAdultPackagePrice(quadsharingPrice);
                }
                break;
    
            case '1 Quad Sharing Room + 1 Triple Sharing Room':
                if (adultCount <= 4) {
                    roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(quadsharingPrice);
                    setAdultPackagePrice(quadsharingPrice);
                } else if (adultCount <= 7) {
                    const adultsInQuad = 4;
                    const adultsInTriple = adultCount - 4;
                    roomAddon = (adultsInQuad * quadsharingPrice) + (adultsInTriple * triplesharingPrice) + (childCount * childPrice);
                    perAdultPrices = [
                        ...Array(adultsInQuad).fill(quadsharingPrice),
                        ...Array(adultsInTriple).fill(triplesharingPrice)
                    ];
                    setAdultPackagePrice(triplesharingPrice);
                } else {
                    roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(quadsharingPrice);
                    setAdultPackagePrice(quadsharingPrice);
                }
                break;
    
            case '4 Double Sharing Room':
                roomAddon = (adultCount * doubleSharingPrice) + (childCount * childPrice);
                perAdultPrices = Array(adultCount).fill(doubleSharingPrice);
                setAdultPackagePrice(doubleSharingPrice);
                break;
    
            case '2 Quad Sharing Room':
                roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
                perAdultPrices = Array(adultCount).fill(quadsharingPrice);
                setAdultPackagePrice(quadsharingPrice);
                break;
    
            case '2 Triple Sharing Room + 1 Double Sharing Room':
                if (adultCount <= 6) {
                    roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(triplesharingPrice);
                    setAdultPackagePrice(triplesharingPrice);
                } else if (adultCount <= 8) {
                    const adultsInTriple = 6;
                    const adultsInDouble = adultCount - 6;
                    roomAddon = (adultsInTriple * triplesharingPrice) + (adultsInDouble * doubleSharingPrice) + (childCount * childPrice);
                    perAdultPrices = [
                        ...Array(adultsInTriple).fill(triplesharingPrice),
                        ...Array(adultsInDouble).fill(doubleSharingPrice)
                    ];
                    setAdultPackagePrice(doubleSharingPrice);
                } else {
                    // More adults than room capacity
                    roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(triplesharingPrice);
                    setAdultPackagePrice(triplesharingPrice);
                }
                break;
    
            case '3 Triple Sharing Room':
                roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
                perAdultPrices = Array(adultCount).fill(triplesharingPrice);
                setAdultPackagePrice(triplesharingPrice);
                break;
    
            case '1 Quad Sharing Room + 1Triple Sharing Room + 1 Double Sharing Room':
                // Room can accommodate 9 people total (4 in quad + 3 in triple + 2 in double)
                if (adultCount <= 4) {
                    roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(quadsharingPrice);
                    setAdultPackagePrice(quadsharingPrice);
                } else if (adultCount <= 7) {
                    const adultsInQuad = 4;
                    const adultsInTriple = adultCount - 4;
                    roomAddon = (adultsInQuad * quadsharingPrice) + (adultsInTriple * triplesharingPrice) + (childCount * childPrice);
                    perAdultPrices = [
                        ...Array(adultsInQuad).fill(quadsharingPrice),
                        ...Array(adultsInTriple).fill(triplesharingPrice)
                    ];
                    setAdultPackagePrice(triplesharingPrice);
                } else if (adultCount <= 9) {
                    const adultsInQuad = 4;
                    const adultsInTriple = 3;
                    const adultsInDouble = adultCount - 7;
                    roomAddon = (adultsInQuad * quadsharingPrice) + (adultsInTriple * triplesharingPrice) + (adultsInDouble * doubleSharingPrice) + (childCount * childPrice);
                    perAdultPrices = [
                        ...Array(adultsInQuad).fill(quadsharingPrice),
                        ...Array(adultsInTriple).fill(triplesharingPrice),
                        ...Array(adultsInDouble).fill(doubleSharingPrice)
                    ];
                    setAdultPackagePrice(triplesharingPrice);
                } else {
                    roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(triplesharingPrice);
                    setAdultPackagePrice(triplesharingPrice);
                }
                break;
    
            case '5 Double Sharing Room':
                roomAddon = (adultCount * doubleSharingPrice) + (childCount * childPrice);
                perAdultPrices = Array(adultCount).fill(doubleSharingPrice);
                setAdultPackagePrice(doubleSharingPrice);
                break;
    
            case '2 Quad Sharing Room + 1 Double Sharing Room':
                if (adultCount <= 8) {
                    roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(quadsharingPrice);
                    setAdultPackagePrice(quadsharingPrice);
                } else if (adultCount <= 10) {
                    const adultsInQuad = 8;
                    const adultsInDouble = adultCount - 8;
                    roomAddon = (adultsInQuad * quadsharingPrice) + (adultsInDouble * doubleSharingPrice) + (childCount * childPrice);
                    perAdultPrices = [
                        ...Array(adultsInQuad).fill(quadsharingPrice),
                        ...Array(adultsInDouble).fill(doubleSharingPrice)
                    ];
                    setAdultPackagePrice(quadsharingPrice);
                } else {
                    // More adults than room capacity
                    roomAddon = (adultCount * quadsharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(quadsharingPrice);
                    setAdultPackagePrice(quadsharingPrice);
                }
                break;
    
            case '2 Triple Sharing Room + 1 Quad Sharing Room':
                if (adultCount <= 6) {
                    roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(triplesharingPrice);
                    setAdultPackagePrice(triplesharingPrice);
                } else if (adultCount <= 10) {
                    const adultsInTriple = 6;
                    const adultsInQuad = adultCount - 6;
                    roomAddon = (adultsInTriple * triplesharingPrice) + (adultsInQuad * quadsharingPrice) + (childCount * childPrice);
                    perAdultPrices = [
                        ...Array(adultsInTriple).fill(triplesharingPrice),
                        ...Array(adultsInQuad).fill(quadsharingPrice)
                    ];
                    setAdultPackagePrice(triplesharingPrice);
                } else {
                    // More adults than room capacity
                    roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(triplesharingPrice);
                    setAdultPackagePrice(triplesharingPrice);
                }
                break;
    
            case '2 Triple Sharing Room + 2 Double Sharing Room':
                if (adultCount <= 6) {
                    roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(triplesharingPrice);
                    setAdultPackagePrice(triplesharingPrice);
                } else if (adultCount <= 10) {
                    const adultsInTriple = 6;
                    const adultsInDouble = adultCount - 6;
                    roomAddon = (adultsInTriple * triplesharingPrice) + (adultsInDouble * doubleSharingPrice) + (childCount * childPrice);
                    perAdultPrices = [
                        ...Array(adultsInTriple).fill(triplesharingPrice),
                        ...Array(adultsInDouble).fill(doubleSharingPrice)
                    ];
                    setAdultPackagePrice(doubleSharingPrice);
                } else {
                    roomAddon = (adultCount * triplesharingPrice) + (childCount * childPrice);
                    perAdultPrices = Array(adultCount).fill(triplesharingPrice);
                    setAdultPackagePrice(triplesharingPrice);
                }
                break;
    
            default:
                roomAddon = 0;
        }
    
        perChildPrices = Array(childCount).fill(childPrice);
        setPerAdultPriceArray(perAdultPrices);
        setPerChildPriceArray(perChildPrices);
    
        return roomAddon;
    };
    const handleBack = () => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false)
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }, 500)

    };
    const limits = {
        adult: { min: 1, max: 10 },
        child: { min: 0, max: 4 },
        infant: { min: 0, max: 4 }
    };
    const handleChangeAccordian = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : null);
    };
    // Handler functions for adults
    const handleAdultIncrement = () => {
        if (adultCount < limits.adult.max) {
            setAdultCount(prevCount => prevCount + 1);
            const newRoomType = getRoomType(adultCount);
            setRoomType(newRoomType);
            const newPrice = calculatePrice(adultCount, roomType);
            setNewPrice(newPrice);
        }
    };

    const handleAdultDecrement = () => {
        if (adultCount > limits.adult.min) {
            setAdultCount(prevCount => prevCount - 1);
        }
    };

    // const onChangeChildDateOfBirth = (event) => {
    //     handleChildIncrement()
    // }
    const onChangeInfantDateOfBirth = (event) => {
        handleInfantIncrement()
    }

    const handleChildIncrement = (event) => {
        if (childCount < limits.child.max) {
            // setIsChild(true);
            // if (childDOB) {
            //     setTravellerDetailsList(prevList => ({ ...prevList, childDOB: [...prevList.childDOB, { childDOB }] }));
            //     setChildDOB('');
            //     setIsChild(false);
            // }
            setChildCount(prevCount => prevCount + 1);
        }
    };
    const handleChildDecrement = () => {
        if (childCount > limits.child.min) {
            setChildCount(prevCount => prevCount - 1);
            setTravellerDetailsList(prevList => {
                const updatedList = [...prevList];
                updatedList[0] = {
                    ...updatedList[0],
                    childDOB: updatedList[0].childDOB.slice(0, -1)
                };
                return updatedList;
            });
        }
    };

    const handleInfantIncrement = () => {
        if (infantCount < limits.infant.max) {
            setIsInfant(true);
            if (infantDOB) {
                setTravellerDetailsList(prevList => {
                    const updatedList = [...prevList];
                    updatedList[0] = {
                        ...updatedList[0],
                        infantDOB: [...updatedList[0].infantDOB, infantDOB]
                    };
                    return updatedList;
                });

                setInfantDOB('');
                setInfantCount(prevCount => prevCount + 1);
                setIsInfant(false);
            }
        }
    };


    const handleInfantDecrement = () => {
        if (infantCount > limits.infant.min) {
            setInfantCount(prevCount => prevCount - 1);

            setTravellerDetailsList(prevList => {
                const updatedList = [...prevList];
                updatedList[0] = {
                    ...updatedList[0],
                    infantDOB: updatedList[0].infantDOB.slice(0, -1)
                };
                return updatedList;
            });
        }
    };


    const handleChangeFirstName = (event) => {
        const value = event.target.value
        if (!value) {
            setFirstNameError('Please provid a valid information')
        } else {
            setFirstNameError('')
        }
        setFirstName(value)
    }
    const handleChangeLastName = (event) => {
        const value = event.target.value
        if (!value) {
            setLastNameError('Please provid a valid information')
        } else {
            setLastNameError('')
        }
        setLastName(value)
    }
    const handleChangeEmail = (event) => {
        const value = event.target.value
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(value)) {
            setEmailError('Please provid a valid information')
        } else if (!value) {
            setEmailError('Please provid a valid information')
        } else {
            setEmailError('')
        }
        setEmail(value)
    }

    const handleChangeMobileNo = (value, country) => {
        if (!value) {
            setMobileNoError('Invalid mobile number format');
        } else {
            setMobileNoError('');
        }
        let countryCode = '+' + country.dialCode;
        setMobileNo(value);
        setDialCode(countryCode)
    };

    const handleChangeNational = (event) => {
        const value = event.target.value;
        if (!value) {
            setNationalError('Please provide valid information');
            setNational('');
            setNationsState([]);
        } else {
            const selectedNation = countryData.filter(country => country.id === value);
            setSelectedNationality(selectedNation[0].name);
            setNationalError('');
            setNational(value);
            const filteredStates = stateData.filter(e => e.id === value)
            setNationsState(filteredStates[0].states);
        }

    }
    const handleChangePincode = (event) => {
        const value = event.target.value;
        const pinCodeRegex = /^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/;

        if (!pinCodeRegex.test(value)) {
            setPinCodeError('Invalid pincode number');
        } else {
            setPinCodeError('');
        }
        setPinCode(value);
    };

    const handleChangeAadharNo = (event) => {
        const value = event.target.value;
        // const aadharRegex = /^[2-9]{1}[0-9]{3}\s[0-9]{4}\s[0-9]{4}$/;
        const aadharRegex = /^[2-9][0-9]{11}$/;
        if (!aadharRegex.test(value)) {
            setAadharNoError('Invalid Aadhar number');
        } else {
            setAadharNoError('');
        }
        setAadharNo(value);
    };

    const handleChangeStateName = (event) => {
        const value = event.target.value
        if (!value) {
            setStateNameError('Please provide a valid information')
        } else {
            setStateNameError('')
        }
        setStateName(value)
    }
    const handleChangeGender = (event) => {
        const value = event.target.value
        if (!value) {
            setGenderError('Please provid a valid information')
        } else {
            setGenderError('')
        }
        setGender(value)
    }

    const handleChangeIsGst = (event) => {
        const value = event.target.value
        if (value === 'Yes') {
            setIsGstModal(true)
            setIsGST('Yes')
        } else {
            setIsGstModal(false)
            setIsGST('No')
        }

    }

    const handleChangeIsPan = (event) => {
        const value = event.target.value
        if (value === "No") {
            setPanNoError('')
            setPanNo('')
        }
        setIsPanNo(value)
    }

    const handleChangePanNo = (event) => {
        const value = event.target.value.toUpperCase();
        const panregex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (!panregex.test(value)) {
            setPanNoError('Invalid PAN Number')
        } else {
            setPanNoError('');
        }
        setPanNo(value);
    }

    const handleAddTravellerDetails = (event) => {
        event.preventDefault();

        let isValid = true;

        if (!firstName) {
            setFirstNameError('Please provide valid information');
            isValid = false;
        }
        if (!lastName) {
            setLastNameError('Please provide valid information');
            isValid = false;
        }
        if (!mobileNo) {
            setMobileNoError('Please provide valid information');
            isValid = false;
        }
        if (!email) {
            setEmailError('Please provide valid information');
            isValid = false;
        }
        if (!national) {
            setNationalError('Please provide valid information');
            isValid = false;
        }
        if (!stateName) {
            setStateNameError('Please provide valid information');
            isValid = false;
        }
        if (!gender) {
            setGenderError('Please provide valid information');
            isValid = false;
        }
        if (!dateOfBirth) {
            setDateOfBirthError('Please provide valid information');
            isValid = false;
        }
        if (isPanNo === 'Yes' && !panNo) {
            setPanNoError('Please provide valid information');
            isValid = false;
        }
        if (selectedNationality === "India") {
            if (!pinCode) {
                setPinCodeError('Please provide a valid information');
                isValid = false;
            }
            if (!aadharNo) {
                setAadharNoError('Please provide a valid information');
                isValid = false;
            }
            if (!aadharImg) {
                setAadharImgError('Please upload Aadhar card Image.');
                isValid = false;
            }
        }

        if (!isValid) return;

        const newAdult = {
            firstName,
            lastName,
            mobileNo,
            email,
            national: selectedNationality,
            state: stateName,
            aadharNo,
            "aadharImage": aadharImg,
            pinCode,
            gender,
            dateOfBirth,
            isPanNo,
            panNo,
            isGST,
        };

        setTravellerDetailsList(prevList => {
            const updatedList = [...prevList];
            updatedList[0] = {
                ...updatedList[0],
                adultDetails: [...updatedList[0].adultDetails, newAdult],
                gstDetails: gstDetails
            };
            return updatedList;
        });

        if (adultCount === travellerDetailsList[0]?.adultDetails?.length + 1) {
            setIsAdultForm(false);
        }

        setSubmitFormCount(prevCount => prevCount + 1);
        setIsGstModal(false);
        handleClearForm();
        setCountry('in')
    };


    const handleAddChildDetails = (event) => {
        event.preventDefault();

        let isValid = true;

        if (!firstName) {
            setFirstNameError('Please provide valid information');
            isValid = false;
        }
        if (!lastName) {
            setLastNameError('Please provide valid information');
            isValid = false;
        }
        if (!gender) {
            setGenderError('Please provide valid information');
            isValid = false;
        }
        if (!childDOB) {
            setChildDOBError('Please provide valid information');
            isValid = false;
        }
        if (aadharNo) {
            if (!aadharImg) {
                setAadharImgError('Please upload Aadhar card Image.')
                isValid = false;
            }
        }
        if (!isValid) return;

        const newChild = {
            firstName,
            lastName,
            aadharNo,
            gender,
            childDOB,
            "aadharImage": aadharImg,
        };

        setTravellerDetailsList(prevList => {
            const updatedList = [...prevList];
            updatedList[0] = {
                ...updatedList[0],
                childDOB: [...updatedList[0].childDOB, newChild]
            };
            return updatedList;
        });

        setIsChildForm(false);
        handleClearForm();
    };

    const handleEdit = (item, index) => {
        setIsAdultForm(true)
        setIndexId(index)
        setIsEdit(true)
        setIsGstEdit(true);
        setFirstName(item.firstName)
        setLastName(item.lastName)
        setMobileNo(item.mobileNo)
        setEmail(item.email)
        const selectedNationality = countryData.filter(country => country.id === item.national);
        // setSelectedNationality(selectedNationality[0]?.name);
        // setNational(selectedNation[0].id)
        const selectedNation = countryData.find(country => country.name === item.national)
        setNational(selectedNation?.id)
        setStateName(item.state)
        setGender(item.gender)
        setDateOfBirth(item.dateOfBirth)
        setIsPanNo(item.isPanNo)
        setPanNo(item.panNo)
        setIsGstModal(false);
        setIsGST(item.isGST);
        setAadharNo(item.aadharNo)
        setPinCode(item.pinCode)
        setAadharImg(item.aadharImage)

    }
    const handleEditChild = (item, index) => {
        setIsChildForm(true)
        setIndexId(index)
        setIsEdit(true)
        setFirstName(item.firstName)
        setLastName(item.lastName)
        setGender(item.gender)
        setChildDOB(item.childDOB)
        setAadharImg(item.aadharImage)
    }
    const handleUpdate = (event) => {
        event.preventDefault();

        let isValid = true;
        if (!firstName) {
            setFirstNameError('Please provide a valid information');
            isValid = false;
        }
        if (!lastName) {
            setLastNameError('Please provide a valid information');
            isValid = false;
        }
        if (!mobileNo) {
            setMobileNoError('Please provide a valid information');
            isValid = false;
        }
        if (!email) {
            setEmailError('Please provide a valid information');
            isValid = false;
        }
        if (!national) {
            setNationalError('Please provide a valid information');
            isValid = false;
        }
        if (!stateName) {
            setStateNameError('Please provide a valid information');
            isValid = false;
        }
        if (selectedNationality === 'India') {
            if (!pinCode) {
                setPinCodeError('Please provide a valid information');
                isValid = false;
            }
            if (!aadharNo) {
                setAadharNoError('Please provide a valid information');
                isValid = false;
            }
            if (!aadharImg) {
                setAadharImgError('Please upload Aadhar card Image!');
                isValid = false;
            }
        }
        if (!gender) {
            setGenderError('Please provide a valid information');
            isValid = false;
        }
        if (!dateOfBirth) {
            setDateOfBirthError('Please provide a valid information');
            isValid = false;
        }

        if (!isValid) return;

        const updatedData = {
            firstName,
            lastName,
            mobileNo,
            email,
            national: selectedNationality,
            state: stateName,
            pinCode,
            aadharNo,
            gender,
            dateOfBirth,
            isPanNo,
            isGST,
            "aadharImage": aadharImg
        };

        setTravellerDetailsList(prevList => {
            const updatedList = [...prevList];
            updatedList[0] = {
                ...updatedList[0],
                adultDetails: updatedList[0].adultDetails.map((item, i) =>
                    i === indexId ? updatedData : item
                ),
                gstDetails: gstDetails
            };
            return updatedList;
        });

        setIsEdit(false);
        setIsAdultForm(false);
        handleClearForm();
    };

    const handleUpdateChildDetails = (event) => {
        event.preventDefault();

        let isValid = true;
        if (!firstName) {
            setFirstNameError('Please provide a valid information');
            isValid = false;
        }
        if (!lastName) {
            setLastNameError('Please provide a valid information');
            isValid = false;
        }
        if (!gender) {
            setGenderError('Please provide a valid information');
            isValid = false;
        }
        if (!childDOB) {
            setChildDOBError('Please provide a valid information');
            isValid = false;
        }
        if (!aadharImg) {
            setAadharImgError('Please upload Aadhar card Image.');
            isValid = false;
        }

        if (!isValid) return;

        const updatedData = {
            firstName,
            lastName,
            aadharNo,
            gender,
            childDOB,
            "aadharImage": aadharImg
        };

        setTravellerDetailsList(prevList => {
            const updatedList = [...prevList];
            updatedList[0] = {
                ...updatedList[0],
                childDOB: updatedList[0].childDOB.map((item, i) =>
                    i === indexId ? updatedData : item
                )
            };
            return updatedList;
        });

        setIsEdit(false);
        setIsChildForm(false);
        handleClearForm();
    };

    const handleDelete = (index) => {
        setTravellerDetailsList(prevList => {
            const updatedList = [...prevList];
            updatedList[0] = {
                ...updatedList[0],
                adultDetails: updatedList[0].adultDetails.filter((_, i) => i !== index)
            };
            return updatedList;
        });
        setSubmitFormCount(prevCount => prevCount - 1);
    };

    const handleDeleteChild = (index) => {
        setTravellerDetailsList(prevList => {
            const updatedList = [...prevList];
            updatedList[0] = {
                ...updatedList[0],
                childDOB: updatedList[0].childDOB.filter((_, i) => i !== index)
            };
            return updatedList;
        });
        setSubmitFormCount(prevCount => prevCount - 1);
    };

    const handleClearForm = () => {
        setFirstName('')
        setFirstNameError('')
        setLastName('')
        setLastNameError('')
        setMobileNo(dialCode)
        setMobileNoError('')
        setEmail('')
        setEmailError('')
        // setMobileNo('')
        setMobileNoError('')
        // setNational('')
        setNationalError('')
        setStateName('')
        setStateNameError('')
        setGender('')
        setGenderError('')
        setDateOfBirth('')
        setDateOfBirthError('')
        setPanNo('')
        setAadharNo('')
        setAadharNoError('')
        setPinCode('')
        setPinCodeError('')
        setIsEdit(false)
        setChildDOB('')
        setChildDOBError('')
        setIsPanNo('No')
        setAadharImgError('')
        setAadharImg('')
        clearAadharField()
        
    }
    const handleReset = () => {
        setActiveStep(0);
    };
    const handleChangeCity = (event) => {
        const value = event.target.value
        if (!value) {
            setCityError('Please provid a valid information')
        } else {
            setCityError('')
        }
        setDepartureCity(value)
        setDepartureDate('')
        setFormattedDate('')
    }
    const handleChangeDOB = (e) => {
        const value = e.target.value;
        if (!value) {
            setDateOfBirthError('Please provid a valid information')
        } else {
            setDateOfBirthError('')
        }
        setDateOfBirth(value);
        // const parts = value.split("-");
        // if (parts.length === 3) {
        //     const formatted = `${parts[2]}/${parts[1]}/${parts[0]}`;
        //     setFormattedDate(formatted);
        // }
    };
    const handleChangeChildDOB = (event) => {
        const value = event.target.value
        if (!value) {
            setChildDOBError('Please provid a valid information')
        } else {
            setChildDOBError('')
        }
        setChildDOB(value);
    }
    const handleChangeInfantDOB = (event) => {
        const value = event.target.value
        if (!value) {
            setInfantDOBError('Please provid a valid information')
        } else {
            setInfantDOBError('')
        }
        setInfantDOB(value);
    }


    const handleOnClosePopup = (data) => {
        if (!data) {
            setIsGST('No')
            setIsGstModal(false);
        } else {
            setIsGST('Yes');
            setIsGstModal(true)
        }
    }

    const handleGstDetails = (data) => {
        setGstDetails(data)
    }

    const handleEditGst = () => {
        setIsGstEdit(false);
        if (isGST === 'Yes') {
            // handleGstDetails(gstDetails)
            setIsGstModal(true)

        } else {
            setIsGstModal(false)

        }
    }


    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <div className="container payment-container" style={{ gap: 5 }}>
                        {isLoading &&
                            <Backdrop
                                sx={{
                                    color: "#fff",
                                    zIndex: (theme) => theme.zIndex.drawer + 1,
                                    backdropFilter: "blur(5px)",
                                    backgroundColor: "rgba(0, 0, 0, 0.4)"
                                }}
                                open={isLoading}
                            >
                                <CustomSpinner color="inherit" />
                            </Backdrop>
                        }
                        <div className="col-md-8">
                            <Card sx={{ display: 'flex', flexDirection: 'column', padding: 4, borderRadius: 2, minHeight: '420px' }}>
                                <Typography sx={{ fontWeight: '600', gap: 0 }}>1.Departure City & Date</Typography>
                                <hr></hr>
                                <FormControl className="mt-3">
                                    <FormLabel
                                        id="departure-city-radio-group-label"
                                        sx={{
                                            fontSize: '16px',
                                            fontWeight: 500,
                                            color: '#2d2b29 !important',
                                            mb: 2,
                                            '&.Mui-focused': {
                                                color: '#2d2b29 !important'
                                            }
                                        }}
                                    >
                                        Departure City
                                    </FormLabel>
                                    <RadioGroup
                                        aria-labelledby="departure-city-radio-group-label"
                                        value={departureCity}
                                        onChange={handleChangeCity}
                                        sx={{
                                            gap: 1,
                                            flexDirection: 'row !important',
                                            '& .MuiFormGroup-root': {
                                                flexDirection: 'row !important'
                                            }
                                        }}
                                    >
                                        {packageData && packageData.departureDetails?.map((departure) => (
                                            <FormControlLabel
                                                key={departure.departureId}
                                                value={departure.cityName}
                                                control={
                                                    <Radio
                                                        sx={{
                                                            color: '#9ca3af', // Default gray color for unselected
                                                            '&.Mui-checked': {
                                                                color: departure.cityName === 'Joining/Leaving' ? '#1976d2' : '#1976d2',
                                                            },
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: 20,
                                                            }
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <span style={{
                                                        textTransform: 'capitalize',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        color: '#333'
                                                    }}>
                                                        {departure.cityName}
                                                    </span>
                                                }
                                                sx={{
                                                    margin: 0,
                                                    padding: '8px 12px',
                                                    border: '1px solid #e5e7eb',
                                                    borderRadius: '8px',
                                                    backgroundColor: departureCity === departure.cityName ? '#f8fafc' : 'transparent',
                                                    width: 'fit-content',
                                                    minWidth: '200px',
                                                    '&:hover': {
                                                        backgroundColor: '#f1f5f9'
                                                    },
                                                    '& .MuiFormControlLabel-label': {
                                                        flex: 1
                                                    }
                                                }}
                                            />
                                        ))}
                                    </RadioGroup>

                                    {departureCity === 'Joining/Leaving' && (
                                        <div className="mt-2" style={{
                                            fontSize: '12px',
                                            fontWeight: 500,
                                            backgroundColor: '#ebf6ff',
                                            width: 'fit-content',
                                            padding: '8px 12px',
                                            borderRadius: '6px',
                                            border: '1px solid #dbeafe'
                                        }}>
                                            *Book your own flights/Trains and join directly at the first destination of the tour
                                        </div>
                                    )}

                                    {cityError && (
                                        <p style={{
                                            color: '#dc2626',
                                            fontSize: '12px',
                                            marginTop: '8px',
                                            marginBottom: 0
                                        }}>
                                            {cityError}
                                        </p>
                                    )}
                                </FormControl>
                                <Box sx={{ mt: 2 }}>
                                    <Box borderBottom={1} borderColor="divider" overflow="auto">
                                        <Tabs
                                            value={activeTab}
                                            onChange={(e, newValue) => handleChange(e, newValue)}
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            aria-label="Month Tabs"
                                        >
                                            {months.map((month, index) => (
                                                <Tab
                                                    key={month}
                                                    label={month}
                                                    id={`month-tab-${index}`}
                                                    aria-controls={`month-tabpanel-${index}`}
                                                />
                                            ))}
                                        </Tabs>
                                    </Box>
                                    <Box>
                                        <Grid container spacing={2} mt={1}>
                                            {months[activeTab] &&
                                                organizedDates[months[activeTab]]?.map((dateInfo, index) => (
                                                    <Grid item key={index}>
                                                        <Card
                                                            sx={{
                                                                width: 96,
                                                                cursor: 'pointer',
                                                                p: 0,
                                                                border:
                                                                    formattedDate === `${String(dateInfo.date.getDate()).padStart(2, '0')} ${["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][dateInfo.date.getMonth()]} ${dateInfo.date.getFullYear()}`
                                                                        ? '2px solid #1976d2'
                                                                        : '1px solid #e0e0e0',
                                                                borderRadius: 2,
                                                            }}
                                                            onClick={() => {
                                                                const selectedDate = dateInfo.date;
                                                                const dd = String(selectedDate.getDate()).padStart(2, '0');
                                                                const mm = selectedDate.getMonth(); // 0-based
                                                                const yyyy = selectedDate.getFullYear();

                                                                const monthNames = [
                                                                    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                                                    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
                                                                ];
                                                                const formatted = `${dd} ${monthNames[mm]} ${yyyy}`;

                                                                setDepartureDate(`${yyyy}-${String(mm + 1).padStart(2, '0')}-${dd}`);
                                                                setFormattedDate(formatted);
                                                                setDepartureDateError('');
                                                            }}
                                                        >
                                                            <CardContent sx={{ p: 0 }}>
                                                                <Box
                                                                    sx={{
                                                                        backgroundColor: "#f5f5f5",
                                                                        textAlign: "center",
                                                                        fontWeight: "500",
                                                                        borderBottom: "1px solid #e0e0e0",
                                                                        py: 1,
                                                                    }}
                                                                >
                                                                    {dateInfo.dayOfWeek}
                                                                </Box>
                                                                <Box
                                                                    display="flex"
                                                                    flexDirection="column"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    px={1.5}
                                                                    mt={2}
                                                                >
                                                                    <Typography variant="h6" fontWeight="bold">
                                                                        {dateInfo.day}
                                                                    </Typography>
                                                                    <Typography variant="body2" color="textSecondary" mt={0.5}>
                                                                        {dateInfo.price}
                                                                    </Typography>
                                                                </Box>
                                                            </CardContent>
                                                        </Card>
                                                    </Grid>
                                                ))}
                                            {months.length === 0 && (
                                                <Typography sx={{ marginLeft: '20px' }} variant="body2" color="textSecondary" fontStyle="italic">
                                                    Sorry...Currently no dates available for this city!
                                                </Typography>
                                            )}
                                        </Grid>
                                        {departureDateError && <p style={{ color: 'red' }}>{departureDateError}</p>}
                                    </Box>
                                </Box>
                            </Card>
                            <div className=' whyneedghoomo mt-2'>
                                <NeedGhoomo />
                            </div>
                            <div className=' trevelling-condition mt-2'>
                                <TravallingCondition packageDetails={packageData} />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <BookingSummary perAdultPriceArray={perAdultPriceArray} perChildPriceArray={perChildPriceArray} onNext={handleNext} onBack={handleBack} travellerDetailsList={travellerDetailsList} perChildPrice={perChildPrice} depCity={departureCity} formattedDate={formattedDate} activeStep={activeStep} packageData={packageData} newPrice={newPrice} perAdultPrice={perAdultPrice} />
                        </div>
                        <div className='whyneedghoomo-mobile mt-2'>
                            <NeedGhoomo />
                        </div>
                        <div className='trevelling-condition-mobile mt-2'>
                            <TravallingCondition packageDetails={packageData} />
                        </div>
                    </div>
                );
            case 1:
                return (
                    <div className="container payment-container" style={{ gap: 5 }}>
                        {isLoading &&
                            <Backdrop
                                sx={{
                                    color: "#fff",
                                    zIndex: (theme) => theme.zIndex.drawer + 1,
                                    backdropFilter: "blur(5px)",
                                    backgroundColor: "rgba(0, 0, 0, 0.4)"
                                }}
                                open={isLoading}
                            >
                                <CustomSpinner color="inherit" />
                            </Backdrop>
                        }
                        <div className="col-md-8">
                            <Card sx={{ display: 'flex', flexDirection: 'column', padding: 4, borderRadius: 2, minHeight: '420px' }}>
                                <Typography sx={{ fontWeight: '600' }}>2.Travellers Count</Typography>
                                <hr></hr>
                                <Box sx={{ mb: 2, mt: 1 }}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={7}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <ManIcon sx={{ mr: 2, color: 'text.secondary' }} />
                                                <Box className='title-subtitle'>
                                                    <Typography variant="subtitle1">Adults</Typography>
                                                    <Typography variant="caption" color="text.secondary">(Above 12 yrs)</Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <IconButton
                                                    size="small"
                                                    onClick={handleAdultDecrement}
                                                    disabled={adultCount <= limits.adult.min}
                                                    sx={{ bgcolor: 'action.hover' }}
                                                >
                                                    <Remove />
                                                </IconButton>
                                                <Typography variant="h6" sx={{ mx: 3 }}>{adultCount}</Typography>
                                                <IconButton
                                                    size="small"
                                                    onClick={handleAdultIncrement}
                                                    disabled={adultCount >= limits.adult.max}
                                                    sx={{ bgcolor: 'action.hover' }}
                                                >
                                                    <Add />
                                                </IconButton>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ mb: 2 }}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={7}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <EscalatorWarningIcon sx={{ mr: 2, color: 'text.secondary' }} />
                                                <Box className='title-subtitle'>
                                                    <Typography variant="subtitle1">Child</Typography>
                                                    <Typography variant="caption" color="text.secondary">(Age 5 - 11 yrs)</Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <IconButton
                                                    size="small"
                                                    onClick={handleChildDecrement}
                                                    disabled={childCount <= limits.child.min}
                                                    sx={{ bgcolor: 'action.hover' }}
                                                >
                                                    <Remove />
                                                </IconButton>
                                                <Typography variant="h6" sx={{ mx: 3 }}>{childCount}</Typography>
                                                <IconButton
                                                    size="small"
                                                    onClick={handleChildIncrement}
                                                    disabled={childCount >= limits.child.max}
                                                    sx={{ bgcolor: 'action.hover' }}
                                                >
                                                    <Add />
                                                </IconButton>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ mb: 2 }}>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item xs={7}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <BabyChangingStationIcon sx={{ mr: 2, color: 'text.secondary' }} />
                                                <Box className='title-subtitle'>
                                                    <Typography variant="subtitle1">Infant</Typography>
                                                    <Typography variant="caption" color="text.secondary">(Age 0 - 5 yr)</Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <IconButton
                                                    size="small"
                                                    onClick={handleInfantDecrement}
                                                    disabled={infantCount <= limits.infant.min}
                                                    sx={{ bgcolor: 'action.hover' }}
                                                >
                                                    <Remove />
                                                </IconButton>
                                                <Typography variant="h6" sx={{ mx: 3 }}>{infantCount}</Typography>
                                                <IconButton
                                                    size="small"
                                                    onClick={handleInfantIncrement}
                                                    disabled={infantCount >= limits.infant.max}
                                                    sx={{ bgcolor: 'action.hover' }}
                                                >
                                                    <Add />
                                                </IconButton>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                                {/* {isChild ? (
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={6} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <TextField
                                                label="Date of birth"
                                                type="date"
                                                InputLabelProps={{ shrink: true }}
                                                value={childDOB}
                                                onChange={(e) => { setChildDOB(e.target.value) }}
                                                fullWidth
                                                inputProps={{
                                                    min: childMinDate,
                                                    max: childMaxDate
                                                }}
                                            />
                                            {childDOBError && <p style={{ color: "red", margin: "2px" }}>{childDOBError}</p>}
                                            <button
                                                type="button"
                                                data-bs-toggle="tooltip"
                                                title="add"
                                                className="btn btn-success d-flex justify-content-center align-items-center "
                                                style={{ backgroundColor: 'lightgray', color: 'green', borderRadius: '50%', height: '25px', width: '25px', marginLeft: '15px', }}
                                                onClick={onChangeChildDateOfBirth}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </button>
                                            <button
                                                type="button"
                                                data-bs-toggle="tooltip"
                                                title="Remove"
                                                className="btn btn-danger d-flex justify-content-center align-items-center "
                                                style={{ backgroundColor: 'lightgray', color: 'red', borderRadius: '50%', height: '25px', width: '25px', marginLeft: '15px', }}
                                                onClick={() => setIsChild(false)}
                                            >
                                                <i className="fa fa-times"></i>
                                            </button>

                                        </Grid>
                                    </Grid>
                                ) : ('')} */}
                                {isInfant ? (
                                    <Grid className='mt-2' container spacing={2}>
                                        <Grid item xs={12} sm={12} md={6} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <TextField
                                                label="Date of birth"
                                                type="date"
                                                InputLabelProps={{ shrink: true }}
                                                value={infantDOB}
                                                onChange={handleChangeInfantDOB}
                                                fullWidth
                                                inputProps={{
                                                    min: infantMinDate,
                                                    max: infantMaxDate
                                                }}
                                            />
                                            {/* {dateOfBirthError && <p style={{ color: "red", margin: "2px" }}>{dateOfBirthError}</p>} */}
                                            <button
                                                type="button"
                                                data-bs-toggle="tooltip"
                                                title="add"
                                                className="btn btn-success d-flex justify-content-center align-items-center "
                                                style={{ backgroundColor: 'lightgray', color: 'green', borderRadius: '50%', height: '25px', width: '25px', marginLeft: '15px', }}
                                                onClick={onChangeInfantDateOfBirth}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </button>
                                            <button
                                                type="button"
                                                data-bs-toggle="tooltip"
                                                title="Remove"
                                                className="btn btn-danger d-flex justify-content-center align-items-center "
                                                style={{ backgroundColor: 'lightgray', color: 'red', borderRadius: '50%', height: '25px', width: '25px', marginLeft: '15px', }}
                                                onClick={() => setIsInfant(false)}
                                            >
                                                <i className="fa fa-times"></i>
                                            </button>
                                        </Grid>
                                    </Grid>

                                ) : ('')}
                                <div className="dorm-book mt-2">
                                    <FormControl>
                                        <RadioGroup
                                            aria-labelledby="room-radio-group"
                                            value={roomType}
                                            name="room-options"
                                            onChange={(e) => {
                                                const selected = e.target.value;
                                                setRoomType(selected);
                                                const newPrice = calculatePrice(adultCount, selected);
                                                setNewPrice(newPrice);
                                            }}
                                        >
                                            {getRoomOptions(totalRoomCount).map((option, idx) => (
                                                <FormControlLabel
                                                    key={idx}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                                {adultCount + childCount + infantCount > 10 &&
                                    <Box sx={{ mt: 2, pt: 1 }}>
                                        <Typography style={{ color: 'red', fontSize: '13px' }}>
                                            {/* Total travelers: {adultCount + childCount + infantCount} */}
                                            Maximum 10 people allowed in a single trip booking...!
                                        </Typography>
                                    </Box>
                                }
                            </Card>
                            <div className=' whyneedghoomo mt-2'>
                                <NeedGhoomo />
                            </div>
                            <div className=' trevelling-condition mt-2'>
                                <TravallingCondition packageDetails={packageData} />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <BookingSummary perAdultPriceArray={perAdultPriceArray} perChildPriceArray={perChildPriceArray} onNext={handleNext} onBack={handleBack} travellerDetailsList={travellerDetailsList} perChildPrice={perChildPrice} perAdultPrice={perAdultPrice} depCity={departureCity} formattedDate={formattedDate} activeStep={activeStep} adultCount={adultCount} roomType={roomType} newPrice={newPrice} childCount={childCount} infantCount={infantCount} packageData={packageData} />
                        </div>
                        <div className='whyneedghoomo-mobile mt-2'>
                            <NeedGhoomo />
                        </div>
                        <div className='trevelling-condition-mobile mt-2'>
                            <TravallingCondition packageDetails={packageData} />
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className="container payment-container" style={{ gap: 5 }}>
                        {isLoading &&
                            <Backdrop
                                sx={{
                                    color: "#fff",
                                    zIndex: (theme) => theme.zIndex.drawer + 1,
                                    backdropFilter: "blur(5px)",
                                    backgroundColor: "rgba(0, 0, 0, 0.4)"
                                }}
                                open={isLoading}
                            >
                                <CustomSpinner color="inherit" />
                            </Backdrop>
                        }
                        <div className="col-md-8">
                            <Card sx={{ display: 'flex', flexDirection: 'column', padding: 4, borderRadius: 2, }}>
                                <Typography sx={{ fontWeight: '600' }}>3.Travellers & Details</Typography>
                                <hr></hr>
                                {/* <Typography className="mt-2 d-flex flex-column">Lead traveller details <span style={{ fontSize: '12px' }}>Enter details as registered in your Aadhaar card</span></Typography> */}
                                <div className='d-flex flex-row justify-content-between align-items-center' style={{ fontSize: '14px' }}>
                                    <div className='d-flex flex-column justify-content-between align-items-start'>
                                        <div>Traveller details<Tooltip style={{ fontSize: '12px', }} title="First person responsible for booking is the lead traveller.All booking processes will be carried out according to the details and documents provided by the lead traveller." placement='bottom-start' arrow>
                                            <IconButton>
                                                <RiInformation2Line style={{ color: 'blue', fontSize: '15px' }} />
                                            </IconButton>
                                        </Tooltip>
                                        </div>
                                        <div style={{ fontSize: '12px' }}>Enter details as registered in your Aadhaar card</div>
                                    </div>
                                    <div className=''>
                                        {!isAdultForm ? (
                                            <button
                                                type="button"
                                                data-bs-toggle="tooltip"
                                                title="add"
                                                className="btn btn-success d-flex justify-content-center align-items-center "
                                                style={{ backgroundColor: 'lightgray', color: 'green', borderRadius: '50%', height: '25px', width: '25px', marginLeft: '15px',boxShadow:'none' }}
                                                onClick={() => setIsAdultForm(true)}
                                                disabled={adultCount === travellerDetailsList[0]?.adultDetails?.length}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                data-bs-toggle="tooltip"
                                                title="Remove"
                                                className="btn btn-link btn-md"
                                                onClick={() => { setIsAdultForm(false); handleClearForm() }}
                                                style={{boxShadow:'none'}}
                                            >
                                                <i className="fa fa-times"></i>
                                            </button>
                                        )}

                                    </div>
                                </div>
                                {isAdultForm &&
                                    <div className='d-flex flex-column align-items-center'>
                                        <Grid container spacing={2} className='travllerdetails-form' sx={{ marginTop: '8px' }}>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <TextField fullWidth label="First Name" variant="outlined" value={firstName} onChange={handleChangeFirstName} />
                                                {firstNameError && <p style={{ color: "red", margin: "2px" }}>{firstNameError}</p>}
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <TextField fullWidth label="Last Name" variant="outlined" value={lastName} onChange={handleChangeLastName} />
                                                {lastNameError && <p style={{ color: "red", margin: "2px" }}>{lastNameError}</p>}
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <PhoneInput
                                                    country={country}
                                                    value={mobileNo}
                                                    onChange={(value, country)=>handleChangeMobileNo(value, country)}
                                                    inputStyle={{ width: '100%', height: '55px' }}
                                                    countryCodeEditable={false}
                                                />
                                                {mobileNoError && <p style={{ color: "red", margin: "2px" }}>{mobileNoError}</p>}
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <TextField fullWidth label="Email Id" variant="outlined" value={email} onChange={handleChangeEmail} />
                                                {emailError && <p style={{ color: "red", margin: "2px" }}>{emailError}</p>}
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="nationality-label">Nationality</InputLabel>
                                                    <Select
                                                        labelId="nationality-label"
                                                        id="nationality-select"
                                                        value={national}
                                                        label="Nationality"
                                                        onChange={handleChangeNational}
                                                    >
                                                        {countryData.map(({ id, name }) => (
                                                            <MenuItem key={id} value={id}>
                                                                {name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>

                                                </FormControl>
                                                {nationalError && <p style={{ color: "red", margin: "2px" }}>{nationalError}</p>}
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="state-label">State</InputLabel>
                                                    <Select
                                                        labelId="state-label"
                                                        id="state-select"
                                                        value={stateName}
                                                        label="state"
                                                        onChange={handleChangeStateName}
                                                    >
                                                        {nationsState?.map(({ id, name }) => (
                                                            <MenuItem key={id} value={name}>
                                                                {name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                {stateNameError && <p style={{ color: "red", margin: "2px" }}>{stateNameError}</p>}
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <FormControl fullWidth >
                                                    <InputLabel id="gender-label">Gender</InputLabel>
                                                    <Select
                                                        labelId="gender-label"
                                                        id="gender-select"
                                                        value={gender}
                                                        label="Gender"
                                                        onChange={handleChangeGender}

                                                    >
                                                        {genders.map((gender) => (
                                                            <MenuItem key={gender} value={gender}>
                                                                {gender}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    {genderError && (
                                                        <p style={{ color: 'red', margin: '4px 14px 0 14px' }}>{genderError}</p>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <TextField
                                                    label="Date of birth"
                                                    type="date"
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{
                                                        min: adultMinDate,
                                                        max: adultMaxDate
                                                    }}
                                                    value={dateOfBirth}
                                                    onChange={handleChangeDOB}
                                                    fullWidth

                                                />
                                                {dateOfBirthError && <p style={{ color: "red", margin: "2px" }}>{dateOfBirthError}</p>}
                                            </Grid>
                                            {selectedNationality === 'India' ? (
                                                <>
                                                    <Grid item xs={12} sm={12} md={6}>
                                                        <TextField fullWidth label="PinCode" variant="outlined" value={pinCode} inputProps={{minLength:6,maxLength:6}} onChange={handleChangePincode} />
                                                        {pinCodeError && <p style={{ color: "red", margin: "2px" }}>{pinCodeError}</p>}
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={6}>
                                                        <TextField fullWidth label="Aadhar No." variant="outlined" value={aadharNo} inputProps={{minLength:12,maxLength:12}} onChange={handleChangeAadharNo} />
                                                        {aadharNoError && <p style={{ color: "red", margin: "2px" }}>{aadharNoError}</p>}
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={6}>
                                                        <label htmlFor="aadharImg" className="form-label">Aadhar Image</label>
                                                        <input
                                                            ref={aadharFileInputRef}
                                                            type="file"
                                                            className={`form-control ${aadharImgError ? 'is-invalid' : ''}`}
                                                            id="aadharImg"
                                                            name='aadharImg'
                                                            onChange={handleFileUpload}
                                                            accept="image/*" // Only allow image files
                                                            required
                                                        />
                                                        <span style={{ fontSize: '10px' }}>Please provide your Aadhaar card details to proceed with ticket booking.</span>
                                                        {aadharImgError && <p style={{ color: 'red' }}>{aadharImgError}</p>}


                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={6}>
                                                        {aadharImg && (
                                                            <div className="d-flex flex-column justify-content-start">
                                                                <img src={aadharImg} alt="Aadhar preview" style={{ width: '150px', height: '150px', objectFit: 'contain', }} />
                                                                <small className="text-success">✓ Aadhar image uploaded successfully</small>
                                                            </div>
                                                        )}
                                                    </Grid>

                                                    {isPanNo === 'Yes' ? (
                                                        <Grid item xs={12} sm={12} md={6}>
                                                            <TextField fullWidth label="PAN" variant="outlined" value={panNo} onChange={handleChangePanNo} />
                                                            {panNoError && <p style={{ color: "red", margin: "2px" }}>{panNoError}</p>}
                                                        </Grid>
                                                    ) : null}
                                                    <Grid item xs={12} sx={{ mt: 1 }}>
                                                        Is PAN operative? <span style={{ fontSize: '10px' }}>You can’t do this later!</span>
                                                        <FormControl className="d-flex flex-column">
                                                            <RadioGroup
                                                                className="d-flex flex-row"
                                                                aria-labelledby="demo-controlled-radio-buttons-group"
                                                                name="controlled-radio-buttons-group"
                                                                value={isPanNo}
                                                                onChange={handleChangeIsPan}
                                                            >
                                                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                                <FormControlLabel value="No" control={<Radio />} label="No" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Grid>
                                                    {
                                                        isGstEdit && indexId === 0 ?
                                                            <Grid item xs={12} sm={12} md={6}>
                                                                You have selected GST As : <strong>{isGST}</strong>
                                                                <button
                                                                    type="button"
                                                                    data-bs-toggle="tooltip"
                                                                    title="Edit Task"
                                                                    className="btn btn-link btn-md"
                                                                    onClick={() => handleEditGst()}
                                                                >
                                                                    <i className="fa fa-edit"></i>
                                                                </button>
                                                            </Grid>
                                                            :
                                                            <>
                                                                {travellerDetailsList[0]?.adultDetails?.length === 0 ? (
                                                                    <Grid item xs={12} sx={{ mt: 1 }} >
                                                                        Do you want to add GST ? <span style={{ fontSize: '10px' }}>You can’t do this later!</span>
                                                                        <FormControl className="d-flex flex-column">
                                                                            {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                                                                            <RadioGroup
                                                                                className="d-flex flex-row"
                                                                                aria-labelledby="demo-controlled-radio-buttons-group"
                                                                                name="controlled-radio-buttons-group"
                                                                                value={isGST}
                                                                                onChange={handleChangeIsGst}
                                                                            >
                                                                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                                                <FormControlLabel value="No" control={<Radio />} label="No" />
                                                                            </RadioGroup>
                                                                            <GstDetailsModal isGstModal={isGstModal} closePopup={handleOnClosePopup}
                                                                                onGstDetails={handleGstDetails} isEditGstData={gstDetails}
                                                                            />
                                                                        </FormControl>
                                                                    </Grid>
                                                                ) : ('')}

                                                            </>
                                                    }
                                                </>
                                            ) : ('')}
                                            <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'flex-end', }}>
                                                <Button className='mb-4 mt-3' type="submit" variant="contained" color="primary" style={{ backgroundColor: '#fff099', color: '#2d2b29', height: '48px' }} onClick={!isEdit ? handleAddTravellerDetails : handleUpdate} >
                                                    {!isEdit ? 'Add Traveller Details' : 'Update Details'}
                                                </Button>
                                            </Grid>
                                        </Grid>

                                    </div>
                                }
                                {childCount > 0 &&
                                    <div className='d-flex flex-row justify-content-between align-items-center' style={{ fontSize: '14px', marginTop: '20px' }}>
                                        <div className='d-flex flex-column justify-content-between align-items-start'>
                                            <div>Child details</div>
                                            <div style={{ fontSize: '12px' }}>Enter details as registered in your Aadhaar card</div>
                                        </div>
                                        <div className=''>
                                            {!isChildForm ? (
                                                <button
                                                    type="button"
                                                    data-bs-toggle="tooltip"
                                                    title="add"
                                                    className="btn btn-success d-flex justify-content-center align-items-center "
                                                    style={{ backgroundColor: 'lightgray', color: 'green', borderRadius: '50%', height: '25px', width: '25px', marginLeft: '15px',boxShadow:'none' }}
                                                    onClick={() => setIsChildForm(true)}
                                                    disabled={childCount === travellerDetailsList[0]?.childDOB?.length}
                                                >
                                                    <i className="fa fa-plus"></i>
                                                </button>
                                            ) : (
                                                <button
                                                    type="button"
                                                    data-bs-toggle="tooltip"
                                                    title="Remove"
                                                    className="btn btn-link btn-md"
                                                    onClick={() => { setIsChildForm(false); handleClearForm() }}
                                                    style={{boxShadow:'none'}}
                                                >
                                                    <i className="fa fa-times"></i>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                }

                                {isChildForm &&
                                    <div className='d-flex flex-column align-items-center'>
                                        <Grid container spacing={2} className='travllerdetails-form' sx={{ marginTop: '8px' }}>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <TextField fullWidth label="First Name" variant="outlined" value={firstName} onChange={handleChangeFirstName} />
                                                {firstNameError && <p style={{ color: "red", margin: "2px" }}>{firstNameError}</p>}
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <TextField fullWidth label="Last Name" variant="outlined" value={lastName} onChange={handleChangeLastName} />
                                                {lastNameError && <p style={{ color: "red", margin: "2px" }}>{lastNameError}</p>}
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <FormControl fullWidth error={Boolean(genderError)}>
                                                    <InputLabel id="gender-label">Gender</InputLabel>
                                                    <Select
                                                        labelId="gender-label"
                                                        id="gender-select"
                                                        value={gender}
                                                        label="Gender"
                                                        onChange={handleChangeGender}

                                                    >
                                                        {genders.map((gender) => (
                                                            <MenuItem key={gender} value={gender}>
                                                                {gender}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    {genderError && (
                                                        <p style={{ color: 'red', margin: '4px 14px 0 14px' }}>{genderError}</p>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <TextField
                                                    label="Date of birth"
                                                    type="date"
                                                    InputLabelProps={{ shrink: true }}
                                                    value={childDOB}
                                                    onChange={handleChangeChildDOB}
                                                    fullWidth
                                                    inputProps={{
                                                        min: childMinDate,
                                                        max: childMaxDate
                                                    }}
                                                />
                                                {childDOBError && <p style={{ color: "red", margin: "2px" }}>{childDOBError}</p>}
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <TextField fullWidth label="Aadhar No." variant="outlined" value={aadharNo} onChange={handleChangeAadharNo} />
                                                {aadharNoError && <p style={{ color: "red", margin: "2px" }}>{aadharNoError}</p>}
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>

                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <label htmlFor="aadharImg" className="form-label">Aadhar Image</label>
                                                <input
                                                    ref={aadharFileInputRef}
                                                    type="file"
                                                    className={`form-control ${aadharImgError ? 'is-invalid' : ''}`}
                                                    id="aadharImg"
                                                    name='aadharImg'
                                                    onChange={handleFileUpload}
                                                    accept="image/*"
                                                    required
                                                />
                                                {aadharImgError && <p style={{ color: 'red' }}>{aadharImgError}</p>}
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                {aadharImg && (
                                                    <div className="d-flex flex-column justify-content-start">
                                                        <img src={aadharImg} alt="Aadhar preview" style={{ width: '150px', height: '150px', objectFit: 'contain' }} />
                                                        <small className="text-success">✓ Aadhar image uploaded successfully</small>
                                                    </div>
                                                )}
                                            </Grid>
                                            <Divider></Divider>
                                            <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'flex-end', }}>
                                                <Button className='mb-4 mt-3' fullWidth type="submit" variant="contained" color="primary" style={{ backgroundColor: '#fff099', color: '#2d2b29', height: '48px', width: '300px' }} onClick={!isEdit ? handleAddChildDetails : handleUpdateChildDetails} >
                                                    {!isEdit ? 'Add Child Details' : 'Update Details'}
                                                </Button>
                                            </Grid>
                                        </Grid>

                                    </div>
                                }
                                {Array.isArray(travellerDetailsList[0]?.adultDetails) &&
                                    (travellerDetailsList[0].adultDetails.length > 0 ||travellerDetailsList[0].childDOB.length > 0 )&&
                                    activeStep === 2 ? (
                                    <div className="table table-responsive mt-3">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Sr.No.</th>
                                                    <th>First Name</th>
                                                    <th>Last Name</th>
                                                    <th>Mobile No.</th>
                                                    {/* <th>Email Id</th> */}
                                                    {/* <th>National</th> */}
                                                    {/* <th>State</th> */}
                                                    <th>Gender</th>
                                                    {/* <th>Date Of Birth</th> */}
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* Adults List */}
                                                <tr>
                                                    <td colSpan={6}><strong>Adults</strong></td>
                                                </tr>
                                                {travellerDetailsList[0]?.adultDetails?.map((item, index) => (
                                                    <tr key={`adult-${index}`}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.firstName}</td>
                                                        <td>{item.lastName}</td>
                                                        <td>{item.mobileNo}</td>
                                                        <td>{item.gender}</td>
                                                        <td>
                                                            <div className="d-flex flex-row justify-content-start align-items-center">
                                                                <button
                                                                    type="button"
                                                                    data-bs-toggle="tooltip"
                                                                    title="Edit Task"
                                                                    className="btn btn-link btn-md"
                                                                    onClick={() => handleEdit(item, index)}
                                                                >
                                                                    <i className="fa fa-edit"></i>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    data-bs-toggle="tooltip"
                                                                    title="Remove"
                                                                    className="btn btn-link btn-md"
                                                                    onClick={() => handleDelete(index)}
                                                                >
                                                                    <i className="fa fa-times"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}

                                                {Array.isArray(travellerDetailsList[0]?.childDOB) && travellerDetailsList[0].childDOB.length > 0 && (
                                                    <>
                                                        <tr>
                                                            <td colSpan={6}><strong>Childs</strong></td>
                                                        </tr>
                                                        {travellerDetailsList[0].childDOB.map((child, childIndex) => (
                                                            <tr key={`child-${childIndex}`}>
                                                                <td>{travellerDetailsList[0].adultDetails.length + childIndex + 1}</td>
                                                                <td>{child.firstName}</td>
                                                                <td>{child.lastName}</td>
                                                                <td>{child.mobileNo || "-"}</td>
                                                                <td>{child.gender}</td>
                                                                <td>
                                                                    <div className="d-flex flex-row justify-content-start align-items-center">
                                                                        <button
                                                                            type="button"
                                                                            data-bs-toggle="tooltip"
                                                                            title="Edit Task"
                                                                            className="btn btn-link btn-md"
                                                                            onClick={() => handleEditChild(child, childIndex)}
                                                                        >
                                                                            <i className="fa fa-edit"></i>
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            data-bs-toggle="tooltip"
                                                                            title="Remove"
                                                                            className="btn btn-link btn-md"
                                                                            onClick={() => handleDeleteChild(childIndex)}
                                                                        >
                                                                            <i className="fa fa-times"></i>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>
                                ) : ('')}
                            </Card>
                            <div className=' whyneedghoomo mt-2'>
                                <NeedGhoomo />
                            </div>
                            <div className=' trevelling-condition mt-2'>
                                <TravallingCondition packageDetails={packageData} />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <BookingSummary perAdultPriceArray={perAdultPriceArray} perChildPriceArray={perChildPriceArray} onNext={handleNext} onBack={handleBack} travellerDetailsList={travellerDetailsList} perChildPrice={perChildPrice} perAdultPrice={perAdultPrice} depCity={departureCity} formattedDate={formattedDate} roomType={roomType} newPrice={newPrice} activeStep={activeStep} adultCount={adultCount} childCount={childCount} infantCount={infantCount} packageData={packageData} childPrice={childPrice} />
                        </div>
                        <div className='whyneedghoomo-mobile mt-2'>
                            <NeedGhoomo />
                        </div>
                        <div className='trevelling-condition-mobile mt-2'>
                            <TravallingCondition packageDetails={packageData} />
                        </div>

                    </div >
                )
            case 3:
                return (
                    <div className="container payment-container" style={{ gap: 5 }}>
                        {isLoading &&
                            <Backdrop
                                sx={{
                                    color: "#fff",
                                    zIndex: (theme) => theme.zIndex.drawer + 1,
                                    backdropFilter: "blur(5px)",
                                    backgroundColor: "rgba(0, 0, 0, 0.4)"
                                }}
                                open={isLoading}
                            >
                                <CustomSpinner color="inherit" />
                            </Backdrop>
                        }
                        <div className="col-md-8">
                            <Card sx={{ display: 'flex', flexDirection: 'column', padding: 4, borderRadius: 2 }}>
                                <Box sx={{display:'flex',flexDirection:{xs:'column',md:'row'},justifyContent:'space-between'}}>
                                    <div>
                                        <Typography sx={{ fontWeight: '600' }}>4.Preview Details and Make Payment</Typography>
                                    </div>
                                    <div>
                                        {activeStep === 3 ? (
                                            <button
                                                type="button"
                                                data-bs-toggle="tooltip"
                                                title="Edit Task"
                                                className="btn btn-link btn-md"
                                                style={{ padding: '5px 0px 8px 5px', fontSize: '14px',boxShadow:'none' }}
                                                onClick={handleBack}
                                            >
                                                <i className="fa fa-edit"></i> Edit Travellers Details
                                            </button>
                                        ) : ('')}
                                    </div>
                                </Box>
                                <hr></hr>
                                {BookingDetails && (
                                    BookingDetails.map((item, index) => (
                                        <ul style={{ fontSize: '13px', listStyle: 'none', padding: 0, lineHeight: 2, marginLeft: 5 }}>
                                            <li className="row mb-2">
                                                <div className="col-md-3">Dept. City</div>
                                                <div className="col-md-8" style={{ textTransform: 'capitalize' }}><strong>{item.departureCity || ''}</strong></div>
                                            </li>
                                            <li className="row mb-2">
                                                <div className="col-md-3">Dept. Date</div>
                                                <div className="col-md-8"><strong>{item.departureDate.split('-').reverse().join('-')}</strong></div>
                                            </li>
                                            <li className="row mb-2">
                                                <div className="col-md-3">Rooms</div>
                                                <div className="col-md-8"><strong>{roomType}</strong></div>
                                            </li>
                                        </ul>
                                    ))
                                )}
                                <div className="mb-2">
                                    {BookingDetails && BookingDetails.map((bookingItem, bIndex) => {
                                        const traveller = bookingItem.travellerDetailsList?.[0] || {};
                                        const adults = traveller.adultDetails || [];
                                        const children = traveller.childDOB || [];
                                        const infants = traveller.infantDOB || [];
                                        return (
                                            <div key={bIndex}>
                                                {/* --- Adults --- */}
                                                {adults.map((item, index) => (
                                                    <Accordion
                                                        className="itineraryaccordion"
                                                        key={`adult-${bIndex}-${index}`}
                                                        expanded={expanded === `adult-${bIndex}-${index}`}
                                                        onChange={handleChangeAccordian(`adult-${bIndex}-${index}`)}
                                                        sx={{
                                                            marginBottom: 2,
                                                            '&::before': {
                                                                backgroundColor: 'transparent!important',
                                                                boxShadow: 'none',
                                                                borderRadius: 3,
                                                            },
                                                        }}
                                                    >
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls={`adult-panel-${index}-content`}
                                                            id={`adult-panel-${index}-header`}
                                                            sx={{
                                                                backgroundColor: '#fffbdf',
                                                                flexDirection: 'row',
                                                                alignItems: 'center',
                                                                gap: 2,
                                                                borderRadius: 3,
                                                            }}
                                                        >
                                                            <Typography
                                                                component="span"
                                                                sx={{
                                                                    fontWeight: 700,
                                                                    backgroundColor: '#fff099',
                                                                    color: '#2d2b29',
                                                                    borderRadius: '10px',
                                                                    px: 2,
                                                                    py: 1,
                                                                    minWidth: '70px',
                                                                    textAlign: 'center',
                                                                    fontSize: { sm: '12px', md: '13px' },
                                                                    display: 'flex',
                                                                    flexShrink: 0,
                                                                    marginRight: 2,
                                                                    alignItems: 'center',
                                                                    height: '40px',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Adult {index + 1}
                                                            </Typography>
                                                            <Typography
                                                                component="span"
                                                                sx={{
                                                                    fontSize: { sm: '12px', sm: '13px' },
                                                                    fontWeight: 600,
                                                                    flex: 1,
                                                                    display: 'flex',
                                                                    whiteSpace: 'normal',
                                                                    wordBreak: 'break-word',
                                                                    alignItems: 'center',

                                                                }}
                                                            >
                                                                {item.firstName} {item.lastName}
                                                            </Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails className="accordion-details">
                                                            <ul style={{ fontSize: '13px', listStyle: 'none', padding: 0, lineHeight: 2 }}>
                                                                <li className="row mb-2">
                                                                    <div className="col-md-3">Full Name</div>
                                                                    <div className="col-md-8">
                                                                        <strong>{`${item.firstName || ''} ${item.lastName || ''}`.trim()}</strong>
                                                                    </div>
                                                                </li>
                                                                <li className="row mb-2">
                                                                    <div className="col-md-3">Mobile No.</div>
                                                                    <div className="col-md-8">
                                                                        <strong>{item.mobileNo || ''}</strong>
                                                                    </div>
                                                                </li>
                                                                <li className="row mb-2">
                                                                    <div className="col-md-3">Email Id</div>
                                                                    <div className="col-md-8">
                                                                        <strong>{item.email || ''}</strong>
                                                                    </div>
                                                                </li>
                                                                <li className="row mb-2">
                                                                    <div className="col-md-3">Nationality</div>
                                                                    <div className="col-md-8">
                                                                        <strong>{item.national || ''}</strong>
                                                                    </div>
                                                                </li>
                                                                {item.pinCode &&
                                                                    <li className="row mb-2">
                                                                        <div className="col-md-3">PinCode</div>
                                                                        <div className="col-md-8">
                                                                            <strong>{item.pinCode || ''}</strong>
                                                                        </div>
                                                                    </li>
                                                                }
                                                                {item.aadharNo &&
                                                                    <li className="row mb-2">
                                                                        <div className="col-md-3">Aadhar No.</div>
                                                                        <div className="col-md-8">
                                                                            <strong>{item.aadharNo || ''}</strong>
                                                                        </div>
                                                                    </li>
                                                                }
                                                                {item.panNo &&
                                                                    <li className="row mb-2">
                                                                        <div className="col-md-3">PAN No.</div>
                                                                        <div className="col-md-8">
                                                                            <strong>{item.panNo || ''}</strong>
                                                                        </div>
                                                                    </li>
                                                                }
                                                                <li className="row mb-2">
                                                                    <div className="col-md-3">State</div>
                                                                    <div className="col-md-8">
                                                                        <strong>{item.state || ''}</strong>
                                                                    </div>
                                                                </li>
                                                                <li className="row mb-2">
                                                                    <div className="col-md-3">Gender</div>
                                                                    <div className="col-md-8">
                                                                        <strong>{item.gender || ''}</strong>
                                                                    </div>
                                                                </li>
                                                                <li className="row mb-2">
                                                                    <div className="col-md-3">Date of Birth</div>
                                                                    <div className="col-md-8">
                                                                        <strong>{item.dateOfBirth.split('-').reverse().join('-') || ''}</strong>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                ))}

                                                {/* --- Children --- */}
                                                {children.map((item, index) => (
                                                    <Accordion
                                                        className="itineraryaccordion"
                                                        key={`child-${bIndex}-${index}`}
                                                        expanded={expanded === `child-${bIndex}-${index}`}
                                                        onChange={handleChangeAccordian(`child-${bIndex}-${index}`)}
                                                        sx={{
                                                            marginBottom: 2,
                                                            '&::before': {
                                                                backgroundColor: 'transparent!important',
                                                                boxShadow: 'none',
                                                                borderRadius: 3,
                                                            },
                                                        }}
                                                    >
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls={`child-panel-${index}-content`}
                                                            id={`child-panel-${index}-header`}
                                                            sx={{
                                                                backgroundColor: '#fffbdf',
                                                                flexDirection: 'row',
                                                                alignItems: 'center',
                                                                gap: 2,
                                                                borderRadius: 3,
                                                            }}
                                                        >
                                                            <Typography
                                                                component="span"
                                                                sx={{
                                                                    fontWeight: 700,
                                                                    backgroundColor: '#fff099',
                                                                    color: '#2d2b29',
                                                                    borderRadius: '10px',
                                                                    px: 2,
                                                                    py: 1,
                                                                    minWidth: '70px',
                                                                    textAlign: 'center',
                                                                    fontSize: { sm: '12px', md: '13px' },
                                                                    display: 'flex',
                                                                    flexShrink: 0,
                                                                    marginRight: 2,
                                                                    alignItems: 'center',
                                                                    height: '40px',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Child {index + 1}
                                                            </Typography>
                                                            <Typography
                                                                component="span"
                                                                sx={{
                                                                    fontSize: { sm: '12px', sm: '13px' },
                                                                    fontWeight: 600,
                                                                    flex: 1,
                                                                    display: 'flex',
                                                                    whiteSpace: 'normal',
                                                                    wordBreak: 'break-word',
                                                                    alignItems: 'center',

                                                                }}
                                                            >
                                                                {item.firstName} {item.lastName}
                                                            </Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails className="accordion-details">
                                                            <ul style={{ fontSize: '13px', listStyle: 'none', padding: 0, lineHeight: 2 }}>
                                                                <li className="row mb-2">
                                                                    <div className="col-md-3">Full Name</div>
                                                                    <div className="col-md-8">
                                                                        <strong>{`${item.firstName || ''} ${item.lastName || ''}`.trim()}</strong>
                                                                    </div>
                                                                </li>
                                                                <li className="row mb-2">
                                                                    <div className="col-md-3">Date of Birth</div>
                                                                    <div className="col-md-8">
                                                                        <strong>{item.childDOB.split('-').reverse().join('-') || ''}</strong>
                                                                    </div>
                                                                </li>
                                                                <li className="row mb-2">
                                                                    <div className="col-md-3">Gender</div>
                                                                    <div className="col-md-8">
                                                                        <strong>{item.gender || ''}</strong>
                                                                    </div>
                                                                </li>
                                                                {item.aadharNo &&
                                                                    <li className="row mb-2">
                                                                        <div className="col-md-3">Aadhar No</div>
                                                                        <div className="col-md-8">
                                                                            <strong>{item.aadharNo || ''}</strong>
                                                                        </div>
                                                                    </li>
                                                                }
                                                            </ul>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                ))}

                                                {/* --- Infants --- */}
                                                {infants.map((item, index) => (
                                                    <Accordion
                                                        className="itineraryaccordion"
                                                        key={`infant-${bIndex}-${index}`}
                                                        expanded={expanded === `infant-${bIndex}-${index}`}
                                                        onChange={handleChangeAccordian(`infant-${bIndex}-${index}`)}
                                                        sx={{
                                                            marginBottom: 2,
                                                            '&::before': {
                                                                backgroundColor: 'transparent!important',
                                                                boxShadow: 'none',
                                                                borderRadius: 3,
                                                            },
                                                        }}
                                                    >
                                                        <AccordionSummary
                                                            expandIcon={<ExpandMoreIcon />}
                                                            aria-controls={`infant-panel-${index}-content`}
                                                            id={`infant-panel-${index}-header`}
                                                            sx={{
                                                                backgroundColor: '#fffbdf',
                                                                flexDirection: 'row',
                                                                alignItems: 'center',
                                                                gap: 2,
                                                                borderRadius: 3,
                                                            }}
                                                        >
                                                            <Typography
                                                                component="span"
                                                                sx={{
                                                                    fontWeight: 700,
                                                                    backgroundColor: '#fff099',
                                                                    color: '#2d2b29',
                                                                    borderRadius: '10px',
                                                                    px: 2,
                                                                    py: 1,
                                                                    minWidth: '70px',
                                                                    textAlign: 'center',
                                                                    fontSize: { sm: '12px', md: '13px' },
                                                                    display: 'flex',
                                                                    flexShrink: 0,
                                                                    marginRight: 2,
                                                                    alignItems: 'center',
                                                                    height: '40px',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                Infant {index + 1}
                                                            </Typography>
                                                            <Typography
                                                                component="span"
                                                                sx={{
                                                                    fontSize: { sm: '12px', sm: '13px' },
                                                                    fontWeight: 600,
                                                                    flex: 1,
                                                                    display: 'flex',
                                                                    whiteSpace: 'normal',
                                                                    wordBreak: 'break-word',
                                                                    alignItems: 'center',

                                                                }}
                                                            >
                                                                {item.firstName} {item.lastName}
                                                            </Typography>
                                                        </AccordionSummary>
                                                        <AccordionDetails className="accordion-details">
                                                            <ul style={{ fontSize: '13px', listStyle: 'none', padding: 0, lineHeight: 2 }}>
                                                                <li className="row mb-2">
                                                                    <div className="col-md-3">Date of Birth</div>
                                                                    <div className="col-md-8">
                                                                        {/* <strong>{item.infantDOB || ''}</strong> */}
                                                                        <strong>{item.split('-').reverse().join('-')}</strong>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                ))}
                                            </div>
                                        );
                                    })}
                                </div>

                                {Array.isArray(travellerDetailsList[0]?.gstDetails) && travellerDetailsList[0].gstDetails.length > 0 && (
                                    <div>
                                        <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>GST Details</h6>
                                        {travellerDetailsList[0].gstDetails.map((item, index) => (
                                            <ul key={index} style={{ fontSize: '13px', listStyle: 'none', padding: 0, lineHeight: 2 }}>
                                                <li className="row mb-2">
                                                    <div className="col-md-3">GSTIN</div>
                                                    <div className="col-md-8"><strong>{item.gstNo || ''}</strong></div>
                                                </li>
                                                <li className="row mb-2">
                                                    <div className="col-md-3">Bill To</div>
                                                    <div className="col-md-8"><strong>{item.billTo}</strong></div>
                                                </li>
                                                <li className="row mb-2">
                                                    <div className="col-md-3">Flat No.</div>
                                                    <div className="col-md-8"><strong>{item.flatNo}</strong></div>
                                                </li>
                                                <li className="row mb-2">
                                                    <div className="col-md-3">Address</div>
                                                    <div className="col-md-8"><strong>{item.address}</strong></div>
                                                </li>
                                                {item.tanNo && (
                                                    <li className="row mb-2">
                                                        <div className="col-md-3">TAN</div>
                                                        <div className="col-md-8"><strong>{item.tanNo}</strong></div>
                                                    </li>
                                                )}
                                            </ul>
                                        ))}
                                    </div>
                                )}

                            </Card>
                            <div className=' whyneedghoomo mt-2'>
                                <NeedGhoomo />
                            </div>
                            <div className=' trevelling-condition mt-2'>
                                <TravallingCondition packageDetails={packageData} />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <BookingSummary perAdultPriceArray={perAdultPriceArray} perChildPriceArray={perChildPriceArray} onNext={handleNext} onBack={handleBack} travellerDetailsList={travellerDetailsList} perChildPrice={perChildPrice} perAdultPrice={perAdultPrice} depCity={departureCity} formattedDate={formattedDate} roomType={roomType} activeStep={activeStep} newPrice={newPrice} adultCount={adultCount} childCount={childCount} infantCount={infantCount} packageData={packageData} childPrice={childPrice} />
                        </div>
                        <div className='whyneedghoomo-mobile mt-2'>
                            <NeedGhoomo />
                        </div>
                        <div className='trevelling-condition-mobile mt-2'>
                            <TravallingCondition packageDetails={packageData} />
                        </div>

                    </div >
                )
            //             case 4:
            // return <div>Make Payment content goes here</div>;
            default:
                return 'Unknown step';
        }
    };

    return (
        <>
            <HeaderComponent />
            <Sidebar className='sidebartoggle' />
            <Toaster
                position="top-right"
                reverseOrder={false}
            />
            <Box className="payment-stepper" sx={{ width: '100%', backgroundColor: '#f3f3f3' }}>
                <Stepper activeStep={activeStep} alternativeLabel sx={{
                    '& .css-3hpdci-MuiSvgIcon-root-MuiStepIcon-root.Mui-completed': {
                        color: 'lawngreen',
                    },
                }}>
                    {steps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};
                        return (
                            <Step key={label} {...stepProps} sx={{ marginTop: 2 }}>
                                <StepLabel {...labelProps}>{label}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                {activeStep === steps.length ? (
                    <React.Fragment>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                            All steps completed - you're finished
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button onClick={handleReset}>Reset</Button>
                        </Box>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                flexDirection: 'row',
                                pt: 2,
                                width: '100%',
                            }}
                        >
                            <div className="container next-back-btn-div mt-2">
                                <Box sx={{ flexGrow: 1 }}>
                                    {(activeStep === 0 || activeStep === 1) && (
                                        <Box className="d-flex flex-column justify-content-start mt-3">
                                            <Box sx={{ fontSize: { xs: '14px', md: '18px' }, color: '#2d2b29', fontWeight: 500 }}>
                                                Select departure city, dates & add guest to book your tour
                                            </Box>
                                            <Box sx={{ fontSize: { xs: '12px', md: '13px' }, color: '#2d2b29', fontWeight: 500 }}>
                                                As seats fill, prices increase! So book today!
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                                {/* <div className="d-flex flex-row justify-content-end">
                                    {activeStep === 0 ? ('') : (
                                        <Button
                                            color="inherit"
                                            disabled={activeStep === 0}
                                            onClick={handleBack}
                                            sx={{ mx: 1, mt: 3, backgroundColor: 'white', borderRadius: 4, width: '100px', padding: '5px', height: { xs: '40px', sm: '40px' } }}
                                        >
                                            <KeyboardBackspaceIcon />Back
                                        </Button>
                                    )}
                                    {activeStep === 3 ? ('') : (
                                        <Button onClick={handleNext} sx={{ mx: 1, mt: 3, backgroundColor: '#fff099', borderRadius: 4, width: '100px', padding: '5px', color: '#2d2b29', height: { xs: '40px', sm: '40px' } }} disabled={(activeStep === 3) || (adultCount + childCount + infantCount > 10)}>
                                            Next<EastIcon sx={{ fontSize: '20px' }} />
                                        </Button>
                                    )}
                                </div> */}
                            </div>
                        </Box>
                        <Box sx={{ mt: 2, pb: 7 }}>
                            {getStepContent(activeStep)}
                        </Box>
                    </React.Fragment>

                )}
            </Box>
            <Footer />
        </>
    );
};

export default PaymentProcess;


